{
  "brandName": "Dashbal",
  "loadingStates": {
    "fetching": "Récupération de vos données...",
    "organizing": "Organisation des informations...",
    "analyzing": "Analyse de vos finances...",
    "syncing": "Synchronisation des données...",
    "almost": "Presque terminé...",
    "finalizing": "Finalisation du flux de données..."
  },
  "navigation": {
    "home": "Espaces de travail",
    "boards": "Espaces de travail",
    "settings": "Paramètres",
    "profile": "Profil",
    "logout": "Déconnexion",
    "recent": "Récent",
    "connectedChannels": "Canaux Connectés",
    "moneyJournal": "Journal de Caisse",
    "confirmLogout": "Êtes-vous sûr de vouloir vous déconnecter ?"
  },
  "auth": {
    "login": "Connexion",
    "register": "Inscription",
    "email": "E-mail",
    "password": "Mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "firstName": "Prénom",
    "lastName": "Nom",
    "name": "Nom",
    "forgotPassword": "Mot de passe oublié ?",
    "noAccount": "Pas de compte ?",
    "hasAccount": "Déjà un compte ?",
    "signUp": "S'inscrire",
    "signIn": "Se connecter",
    "emailPlaceholder": "vous@exemple.com",
    "passwordPlaceholder": "••••••••",
    "forgotPasswordTitle": "Mot de passe oublié ?",
    "forgotPasswordDescription": "Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    "sendResetLink": "Envoyer le lien",
    "backToSignIn": "Retour à la connexion",
    "checkYourEmail": "Vérifiez votre e-mail",
    "resetLinkSentTo": "Nous avons envoyé un lien de réinitialisation à :",
    "whatToDo": "Que faire :",
    "openEmailInbox": "Ouvrez votre boîte de réception",
    "clickResetLink": "Cliquez sur le lien de réinitialisation dans l'e-mail",
    "createNewPassword": "Créez un nouveau mot de passe sécurisé",
    "linkExpiresIn30": "Le lien expirera dans 30 minutes pour des raisons de sécurité.",
    "cantFindEmail": "Vous ne trouvez pas l'e-mail ? Vérifiez votre dossier spam.",
    "resetPasswordTitle": "Réinitialiser le mot de passe",
    "resetPasswordDescription": "Entrez votre nouveau mot de passe sécurisé ci-dessous.",
    "newPassword": "Nouveau mot de passe",
    "passwordRequirements": "Min 8 caractères, lettres et chiffres requis",
    "resetPassword": "Réinitialiser",
    "passwordMinLength": "Le mot de passe doit contenir au moins 8 caractères.",
    "passwordRequireNumber": "Le mot de passe doit contenir au moins un chiffre.",
    "passwordRequireLetter": "Le mot de passe doit contenir au moins une lettre.",
    "passwordsDoNotMatch": "Les mots de passe ne correspondent pas.",
    "passwordResetSuccess": "Mot de passe réinitialisé !",
    "passwordResetSuccessMessage": "Votre mot de passe a été mis à jour avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    "resetFailed": "Nous n'avons pas pu réinitialiser votre mot de passe",
    "couldNotResetPassword": "Nous n'avons pas pu réinitialiser votre mot de passe.",
    "thisCouldHappenIf": "Cela peut arriver si :",
    "linkExpired": "Le lien de réinitialisation a expiré",
    "linkAlreadyUsed": "Le lien a déjà été utilisé",
    "linkInvalid": "Le lien est invalide",
    "requestNewLink": "Demander un nouveau lien",
    "missingResetToken": "Problème de lien d'accès",
    "noTokenMessage": "Aucun jeton de réinitialisation n'a été trouvé dans l'URL. Veuillez cliquer à nouveau sur le lien dans votre e-mail, ou demandez une nouvelle réinitialisation.",
    "requestPasswordReset": "Demander une réinitialisation",
    "continueWithGoogle": "Continuer avec Google",
    "continueWithApple": "Continuer avec Apple",
    "continueWithFacebook": "Continuer avec Facebook",
    "continueWithEmail": "Continuer avec Email",
    "continueWithTikTok": "Continuer avec TikTok",
    "registrationAgreement": "En vous inscrivant, vous acceptez nos <0>Conditions d'utilisation</0> et notre <1>Politique de confidentialité</1>.",
    "verifyingEmail": "Vérification de votre e-mail...",
    "emailVerified": "E-mail Vérifié !",
    "alreadyVerified": "Déjà Vérifié",
    "verificationFailed": "Nous n'avons pas pu vérifier votre e-mail",
    "verificationLinkExpired": "Le lien de vérification a expiré. Veuillez en demander un nouveau.",
    "verificationLinkUsed": "Ce lien de vérification a déjà été utilisé.",
    "verificationLinkInvalid": "Le lien de vérification est invalide.",
    "verificationNoToken": "Problème de confirmation d'e-mail",
    "verificationEmailSent": "E-mail de vérification envoyé ! Vérifiez votre boîte de réception.",
    "resendEmailPrompt": "Vous ne l'avez pas reçu ? Renvoyer l'e-mail",
    "cantFindEmailHelp": "Vous ne trouvez pas l'e-mail ? Vérifiez vos spams ou <0>utilisez une autre adresse e-mail</0>.",
    "resendIn": "Renvoyer dans {{seconds}}s",
    "requestNewVerification": "Demander un nouvel e-mail de vérification",
    "signInToResend": "Connectez-vous pour renvoyer",
    "resetPasswordError": "Échec de la réinitialisation du mot de passe. Le lien peut être expiré.",
    "copyright": "© {{year}} Dashbal. Tous droits réservés.",
    "securingConnection": "Sécurisation de la connexion",
    "connectionSuccessful": "Succès !",
    "connectionFailed": "Échec de la connexion",
    "verifyingWithProvider": "Vérification de votre compte {{provider}}...",
    "redirecting": "Génial ! Nous vous redirigeons maintenant...",
    "socialLoginError": "Nous n'avons pas pu vérifier votre identité. Veuillez réessayer.",
    "pleaseWaitVerifying": "Please wait while we verify your email address.",
    "emailVerifiedSuccess": "Your email has been verified successfully.",
    "accountActivated": "Your account is now fully activated. You can start using all Dashbal features.",
    "alreadyVerifiedMessage": "Your email address has already been verified. You",
    "noVerificationTokenMessage": "No verification token was found in the URL. Please click the link in your email again, or request a new verification email.",
    "goToLogin": "Go to Login",
    "welcomeToDashbal": "Welcome to Dashbal",
    "welcomeWithName": "Welcome to Dashbal, {{name}}!",
    "or": "ou",
    "useMagicLink": "Se connecter avec un lien magique",
    "sendMagicLink": "Envoyer le lien magique",
    "magicLinkDescription": "Entrez votre e-mail et nous vous enverrons un lien de connexion sécurisé. Aucun mot de passe requis.",
    "magicLinkSentTo": "Nous avons envoyé un lien de connexion à :",
    "magicLinkExpiry": "Le lien expirera dans 15 minutes.",
    "magicLinkSendError": "Nous n'avons pas pu envoyer le lien magique. Veuillez réessayer.",
    "resendMagicLink": "Renvoyer",
    "magicLinkVerifying": "Connexion en cours...",
    "magicLinkPleaseWait": "Veuillez patienter pendant que nous vérifions votre lien magique.",
    "magicLinkSuccess": "Vous êtes connecté !",
    "magicLinkRedirecting": "Redirection vers votre tableau de bord...",
    "magicLinkFailed": "Échec de la connexion",
    "magicLinkExpired": "Ce lien magique a expiré. Veuillez en demander un nouveau.",
    "magicLinkInvalid": "Ce lien magique est invalide ou a déjà été utilisé.",
    "magicLinkVerifyError": "Nous n'avons pas pu vérifier votre lien magique. Veuillez réessayer.",
    "magicLinkNoToken": "Aucun jeton de lien magique trouvé. Veuillez cliquer à nouveau sur le lien dans votre e-mail."
  },
  "boards": {
    "title": "Espaces de travail",
    "subtitle": "Gérez vos espaces de travail et suivez vos données financières",
    "createBoard": "Créer un espace de travail",
    "boardName": "Nom de l'espace de travail",
    "boardDescription": "Description de l'espace de travail",
    "noBoards": "Aucun espace de travail pour l'instant",
    "createFirstBoard": "Créez votre premier espace de travail pour commencer",
    "name": "Nom",
    "lastModified": "Modifié",
    "owner": "Propriétaire",
    "you": "Vous",
    "lastUpdated": "Dernière mise à jour",
    "connections": "Sources de Données Connectées",
    "connectionsDescription": "Sources de données liées à ce tableau. Cliquez pour gérer les sélections.",
    "deleteBoard": "Supprimer l'espace de travail",
    "editBoard": "Modifier l'espace de travail",
    "duplicateBoard": "Dupliquer l'espace de travail",
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer cet espace de travail ?",
    "deleteConfirm": "Êtes-vous sûr de vouloir supprimer cet espace de travail ?",
    "deleteWarning": "Cette action ne peut pas être annulée.",
    "alerts": {
      "editModeTitle": "Mode Édition",
      "editModeMessage": "Veuillez enregistrer ou annuler les modifications avant de changer de page.",
      "deletePageTitle": "Supprimer la page",
      "deletePageMessage": "Êtes-vous sûr de vouloir supprimer cette page ?",
      "deletePageError": "Échec de la suppression de la page",
      "reorderPagesError": "Échec du réordonnancement des pages"
    },
    "ai": {
      "title": "Tâches IA",
      "processing": "L'IA traite actuellement votre demande...",
      "processingStatus": "Traitement en cours...",
      "interruptedStatus": "Interrompu",
      "completedStatus": "Terminé",
      "backToHistory": "Retour à l'historique",
      "promptPlaceholder": "Demandez à l'IA d'aider avec votre tableau...",
      "messagePlaceholder": "Message à l'IA...",
      "history": "Historique",
      "resumingConversation": "Reprise de la conversation sur : \"{{prompt}}\". Comment puis-je vous aider davantage ?",
      "status": {
        "processing": "Traitement en cours...",
        "interrupted": "Interrompu",
        "completed": "Terminé",
        "executingTask": "Exécution de la tâche : {{task}}...",
        "executionStarted": "Exécution commencée...",
        "executionFailed": "Nous n'avons pas pu terminer les tâches.",
        "executionComplete": "Exécution terminée.",
        "executionCancelled": "Je n'exécuterai pas ces tâches."
      },
      "stopTask": "Arrêter la tâche",
      "deleteConversation": "Supprimer la conversation",
      "hideReview": "Masquer la revue",
      "reviewTasks": "Revoir les tâches",
      "reviewTasksTitle": "Revoir les tâches",
      "selectTasksDescription": "Veuillez sélectionner les tâches que vous souhaitez que l'IA exécute :",
      "validateExecute": "Valider & Exécuter",
      "acceptedTasksTitle": "Tâches effectuées",
      "acceptedTasksDescription": "Ces actions ont été appliquées automatiquement. Elles sont affichées ici à titre informatif.",
      "acceptedTasksMessage": "J'ai effectué les actions suivantes pour vous.",
      "acceptedSection": "Déjà effectué",
      "pendingSection": "En attente d'approbation",
      "taskDone": "Fait",
      "taskFailed": "Échec",
      "viewAcceptedTasks": "Voir les tâches effectuées",
      "hideAcceptedTasks": "Masquer les tâches",
      "confirmDeleteTitle": "Supprimer la conversation ?",
      "confirmDeleteMessage": "Êtes-vous sûr de vouloir supprimer cette conversation sur \"{{prompt}}\" ? Cette action ne peut pas être annulée.",
      "mock": {
        "approvalMessage": "J'ai analysé votre demande et préparé les tâches suivantes à exécuter. Veuillez les examiner et les approuver.",
        "executedMessage": "Les tâches ont été exécutées avec succès.",
        "generalAnalysis": "J'ai analysé votre tableau en fonction de votre demande : \"{{prompt}}\".\n\n- Les données indiquent une performance constante.\n- Il n'y a pas d'anomalies majeures dans les données récentes.\n- Faites-moi savoir si vous avez besoin de visualisations spécifiques.",
        "task1": "Créer un nouveau graphique de revenus pour le T3",
        "task2": "Mettre à jour les taux de change à la dernière valeur",
        "task3": "Supprimer les entrées de dépenses redondantes dans le canal A"
      },
      "quotaExceeded": "Vous avez atteint votre quota hebdomadaire d'IA. Votre capacité commencera à se réinitialiser **{{resetTime}}**.",
      "errorMessage": "Désolé, une erreur est survenue lors du traitement de votre demande.",
      "retry": "Réessayer",
      "responses": {
        "followUpActions": "I",
        "followUpAnalysis": "I"
      }
    },
    "boardRenamed": "Espace de travail renommé avec succès",
    "content": "Contenu de l'espace de travail",
    "noContent": "Aucun contenu pour l'instant",
    "noContentDescription": "Connectez des canaux ou ajoutez des journals pour commencer à visualiser vos données.",
    "addContent": "Ajouter du contenu",
    "emptyBoardTitle": "Commencez à construire votre tableau",
    "emptyBoardDescription": "Vous n'avez pas encore de pages. Créez une page à partir d'un modèle pour commencer à visualiser vos données.",
    "createPageFromTemplate": "Créer une page à partir d'un modèle",
    "templates": "Modèles",
    "addCharts": "Ajouter des graphiques",
    "emptyStateNoDataTitle": "Connectez vos données",
    "emptyStateNoDataDescription": "Connectez vos canaux ou ajoutez des journaux pour commencer à visualiser vos finances.",
    "connectData": "Connecter des données",
    "savePageAsTemplate": "Enregistrer la page comme modèle",
    "boardCenterpiece": "Toutes les sources de données connectées à ce tableau",
    "addConnection": "Ajouter une connexion",
    "addConnectionDescription": "Connectez une source de données pour commencer",
    "boardNameUpdated": "Nom du tableau mis à jour avec succès",
    "addConnectionType": "Ajouter une Connexion",
    "connectedChannel": "Canal Connecté",
    "connectedChannelDescription": "Liez des données depuis vos plateformes connectées",
    "moneyJournal": "Journal de Caisse",
    "moneyJournalDescription": "Ajoutez des opérations depuis vos journaux",
    "selectChannelSource": "Sélectionner la Source du Canal",
    "selectChannelSourceDescription": "Choisissez parmi vos canaux connectés ou ajoutez-en un nouveau",
    "selectFromExisting": "Sélectionner parmi l'Existant",
    "selectFromExistingChannels": "Choisir parmi les canaux connectés",
    "addNewChannelDescription": "Connecter une nouvelle plateforme",
    "selectJournalSource": "Sélectionner la Source du Journal",
    "selectJournalSourceDescription": "Choisissez parmi les journaux existants ou créez-en un nouveau",
    "selectFromExistingJournals": "Choisir parmi les journaux existants",
    "addNewJournal": "Ajouter un Nouveau Journal",
    "addNewJournalDescription": "Créer un nouveau journal de caisse",
    "selectChannel": "Sélectionner un Canal",
    "selectChannelToAdd": "Choisissez un canal à ajouter à votre tableau",
    "noAvailableChannels": "Aucun canal disponible à ajouter",
    "selectJournal": "Sélectionner un Journal",
    "selectJournalToAdd": "Choisissez un journal à ajouter à votre tableau",
    "noAvailableJournals": "Aucun journal disponible à ajouter",
    "returnToBoard": "Return to Board",
    "returnToBoardConfirm": "You'll be redirected back to {{boardName}} shortly.",
    "returnNow": "Return Now",
    "confirmRemoveChannel": "Are you sure you want to remove this channel? It will be removed from the board along with all its data.",
    "confirmRemoveJournal": "Are you sure you want to remove this journal from the board?",
    "renameBoard": "Rename Board",
    "noConnections": "No connections yet. Click + to add sources.",
    "noConnectionsConnect": "Connect a channel to start analysing your data.",
    "noConnectionsSelect": "Select data from your connected channels.",
    "quitBoardTitle": "Quitter le tableau ?",
    "quitBoardMessage": "Vous êtes sur le point de quitter le tableau actuel. Toute modification de mise en page non enregistrée sera perdue.",
    "manageJournalsTitle": "Aller à la bibliothèque des journaux",
    "manageJournalsMessage": "Pour ajouter un nouveau journal de trésorerie, vous devez vous rendre dans votre bibliothèque de journaux pour un moment. Ne vous inquiétez pas, vous pourrez facilement revenir à votre tableau de bord après.",
    "manageJournalsConfirm": "Aller aux journaux",
    "unsavedChangesAlert": "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?",
    "backToExplorer": "Retour à l'Explorateur",
    "quitBoardToManageChannelsMessage": "Vous êtes sur le point de quitter le tableau actuel pour gérer vos canaux connectés. Toute modification de mise en page non enregistrée sera perdue.",
    "loadingFinance": "Chargement des données financières...",
    "financeError": "Nous avons du mal à charger vos données",
    "noFinanceData": "Aucune donnée financière disponible",
    "selectItemsHint": "Sélectionnez des éléments et une plage de dates pour voir le graphique en cascade",
    "loadingTemplates": "Chargement des modèles...",
    "missingConnection": "Connexion manquante",
    "connectedData": "Données Connectées",
    "layout": {
      "title": "Mise en Page",
      "description": "Configurez votre mise en page avec des graphiques et des composants. Prend en charge les grilles réactives et les animations fluides."
    },
    "disconnectedWarning": "Ce canal est déconnecté. Le tableau ne pourra pas récupérer de nouvelles données de celui-ci.",
    "boardSpec": "Board Spec",
    "backTo": "Back to",
    "board": "Board",
    "viewNotice": "Voir la notification",
    "tips": {
      "connectSources": "Connecter des sources",
      "connectSourcesDesc": "Plus vous connectez de canaux, plus vos analyses financières automatisées deviennent puissantes.",
      "moneyJournal": "Journal de Caisse",
      "moneyJournalDesc": "Suivez vos dépenses manuelles et votre trésorerie avec le Journal de Caisse pour compléter votre vision financière.",
      "support": "Communauté et Support",
      "supportDesc": "Rejoignez notre communauté d'entrepreneurs ou parlez à nos experts pour tirer le meilleur parti de Dashbal."
    }
  },
  "boardSpecs": {
    "header": "Spécifications du tableau",
    "editTitle": "Modifier la spécification",
    "addTitle": "Ajouter une spécification",
    "specNameLabel": "Nom de la spécification",
    "specNamePlaceholder": "ex. TVA à payer, Impôt sur le revenu",
    "formulaLabel": "Formule",
    "formulaPlaceholder": "Saisissez une connexion... (ex. commerce.all.revenus)",
    "errorsTitle": "Erreurs",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saving": "Enregistrement...",
    "specNameRequired": "Le nom de la spécification est obligatoire",
    "failedToSave": "Nous n'avons pas pu enregistrer votre calcul",
    "types": {
      "channel": "canal",
      "journal": "journal",
      "item": "élément",
      "category": "catégorie",
      "special": "spécial"
    },
    "errors": {
      "empty": "La formule est vide",
      "unexpectedOperator": "Vérifiez les symboles de votre formule",
      "endsInOperator": "Votre formule ne doit pas se terminer par un opérateur",
      "invalidNumber": "Veuillez vérifier les nombres dans votre formule",
      "numberEndsInDot": "Un nombre ne peut pas se terminer par un point",
      "invalidChar": "Nous avons trouvé un caractère non reconnu dans votre formule",
      "endsInDot": "La formule ne peut pas se terminer par un point",
      "unbalancedParenthesis": "Vérifiez vos parenthèses ouvrantes et fermantes",
      "doubleDots": "Les doubles points ne sont pas autorisés",
      "invalidSyntaxTerminal": "La formule doit se terminer par une valeur valide",
      "incompleteAll": "Référence incomplète : all. Catégorie attendue",
      "incompleteCategory": "Catégorie incomplète",
      "invalidCategory": "Catégorie invalide : {{value}}",
      "allFollowedByCategory": "Le mot-clé « all » doit être suivi directement d’une catégorie",
      "unknownConnection": "Connexion inconnue : {{value}}",
      "horizontalLineSeparator": "--------------------------------------------------",
      "onlyCategoryAfterAll": "Seule une catégorie peut suivre « all »",
      "itemNotFound": "Élément « {{item}} » introuvable sous « {{parent}} »",
      "incompleteReference": "Référence incomplète",
      "expectedItemOrAll": "Référence incomplète : élément ou « all » attendu",
      "expectedCategoryAtEnd": "Catégorie attendue en fin d’expression",
      "incompleteReferenceExpectedCategory": "Référence incomplète. Catégorie attendue.",
      "invalidItemOrCategory": "Nous n'avons pas pu trouver cet élément ou cette catégorie"
    },
    "addSpec": "Add Spec"
  },
  "featureExplanation": {
    "connections": {
      "title": "Connexions du Tableau",
      "description": "Connectez vos sources de données comme Shopify ou Meta. Le tableau de bord centralise toutes vos connexions pour créer un jeu de données unifié et exploitable."
    },
    "specs": {
      "title": "Board spec",
      "description": "Une board spec est une formule qui transforme les données connectées en nouvelles valeurs dérivées, créant ainsi un flux de données supplémentaire relié au tableau de bord aux côtés de la source originale."
    },
    "connection": {
      "label": "Connexion"
    },
    "spec": {
      "label": "Spec"
    },
    "board": {
      "label": "Tableau"
    },
    "liveSource": "Source en Direct"
  },
  "charts": {
    "currentlyUnavailable": "Ce graphique est actuellement indisponible",
    "addCharts": "Ajouter des graphiques",
    "shipping": "Revenus d'expédition",
    "shippingPerOrder": "Revenu expédition/commande",
    "categories": {
      "all": "Tous",
      "financial": "Financier",
      "decision": "Décision",
      "operation": "Opération",
      "customerBehavior": "Comportement Client",
      "prediction": "Prédiction",
      "risk": "Risque",
      "expert": "Expert",
      "other": "Autre"
    },
    "titles": {
      "total_revenue": "Chiffre d'affaires total",
      "total_expenses": "Dépenses totales",
      "net_profit_kpi": "Bénéfice net",
      "orders_kpi": "Commandes",
      "ad_spend_kpi": "Dépenses publicitaires",
      "aov_kpi": "Panier moyen",
      "net_profit_over_time": "Bénéfice net dans le temps",
      "profit_waterfall": "Cascade de profit",
      "profit_margin_over_time": "Marge bénéficiaire % dans le temps",
      "income_vs_costs": "Revenus vs Coûts",
      "daily_pl_table": "Tableau P&L quotidien",
      "running_profit": "Profit cumulé",
      "profit_period_comparison": "Profit : période actuelle vs précédente",
      "roas_by_platform": "ROAS par plateforme",
      "roas_over_time": "ROAS dans le temps",
      "blended_mer": "Efficacité marketing (MER)",
      "ad_spend_percent": "Dépense pub en % du CA",
      "cpa_over_time": "Coût par commande dans le temps",
      "campaign_roas_leaderboard": "Classement de rentabilité des campagnes",
      "ad_set_efficiency_scatter": "Carte d'efficacité des ensembles pub",
      "creative_performance_table": "Tableau de performance des créatives",
      "ad_funnel": "Entonnoir pub : Vues → Clics → Commandes",
      "cpm_trend": "Tendance CPM (coût de portée)",
      "cpc_trend": "Tendance du coût par clic",
      "wasted_ad_spend": "Dépense pub gaspillée",
      "ctr_over_time": "Taux de clic dans le temps",
      "best_sellers_by_revenue": "Meilleures ventes par CA",
      "revenue_concentration": "Concentration du CA (80/20)",
      "product_sales_trend": "Tendance des ventes produit",
      "units_sold_ranking": "Classement par unités vendues",
      "revenue_per_unit": "Revenu par unité par produit",
      "product_return_rate": "Taux de retour par produit",
      "refund_damage_by_product": "Impact des remboursements par produit",
      "product_channel_matrix": "Matrice Produit × Canal",
      "expense_category_donut": "Répartition des dépenses",
      "expense_category_trend": "Tendance des catégories de coûts",
      "payment_processing_fees": "Frais de traitement des paiements",
      "payment_fees_percent": "Frais de paiement en % du CA",
      "shipping_cost_over_time": "Revenus d'expédition dans le temps",
      "shipping_per_order": "Revenu d'expédition moyen par commande",
      "discount_total_and_rate": "Remises accordées",
      "journal_expense_breakdown": "Répartition des dépenses manuelles",
      "journal_expenses_over_time": "Dépenses manuelles dans le temps",
      "true_cost_per_order": "Coût réel par commande",
      "expense_anomaly_detector": "Pics de dépenses inhabituels",
      "daily_inflows_outflows": "Entrées vs Sorties quotidiennes",
      "cumulative_cash_position": "Solde de trésorerie cumulé",
      "ad_spend_vs_revenue_timing": "Timing pub vs revenus",
      "weekly_cash_summary": "Flux de trésorerie hebdomadaire",
      "break_even_day": "Jour de rentabilité",
      "money_flow_sankey": "Diagramme de flux financier",
      "return_rate_over_time": "Taux de retour dans le temps",
      "refund_amount_over_time": "Montant des remboursements dans le temps",
      "refund_type_breakdown": "Répartition par type de remboursement",
      "refund_true_cost": "Coût réel des remboursements",
      "most_returned_products": "Produits les plus retournés",
      "paid_vs_organic_revenue": "Revenus payants vs organiques",
      "paid_vs_organic_trend": "Tendance payant vs organique",
      "revenue_by_utm_source": "CA par source de trafic",
      "revenue_by_utm_campaign": "CA par campagne marketing",
      "unattributed_revenue": "Revenus non attribués",
      "purchase_frequency": "Fréquence d'achat",
      "top_customers_by_revenue": "Meilleurs clients par dépense",
      "customer_concentration": "Concentration du CA client",
      "new_vs_returning_revenue": "CA nouveaux vs clients récurrents",
      "avg_revenue_per_customer": "CA moyen par client",
      "revenue_period_comparison": "CA : période actuelle vs précédente",
      "order_volume_over_time": "Volume de commandes dans le temps",
      "aov_trend": "Tendance du panier moyen",
      "revenue_vs_ad_spend_growth": "Croissance CA vs croissance dépense pub",
      "spend_vs_roas_scatter": "Dépense vs efficacité du retour",
      "sales_by_day_of_week": "Ventes par jour de la semaine",
      "revenue_forecast": "Prévision de CA",
      "expense_forecast": "Prévision des dépenses",
      "profit_forecast": "Prévision de profit",
      "break_even_projection": "Projection de rentabilité",
      "seasonal_index": "Meilleurs et pires jours",
      "what_if_simulator": "Scénario hypothétique",
      "activity_timeline": "Chronologie d'activité",
      "revenue_with_action_markers": "CA avec marqueurs d'actions",
      "budget_change_impact": "Impact des changements de budget",
      "budget_increase_efficiency": "Efficacité des augmentations de budget",
      "campaign_toggle_impact": "Impact lancement/pause de campagne",
      "pause_resume_comparison": "Performance pause/reprise",
      "creative_swap_performance": "Performance du changement de créative",
      "audience_change_impact": "Impact du changement d'audience",
      "ad_approval_tracker": "Suivi des approbations pub",
      "campaign_lifecycle": "Vue cycle de vie campagne",
      "product_launch_performance": "Performance des lancements produits",
      "product_removal_impact": "Impact du retrait de produits",
      "promo_discount_rule_impact": "Impact des promotions",
      "refund_spike_analysis": "Analyse des pics de remboursement",
      "order_fulfillment_funnel": "Entonnoir de traitement des commandes",
      "cancellation_rate_over_time": "Taux d'annulation dans le temps",
      "activity_volume_vs_revenue": "Volume d'activité vs CA",
      "billing_issues_timeline": "Problèmes de facturation",
      "action_breakdown_by_type": "Répartition des actions par type",
      "before_after_any_action": "Avant/Après toute action"
    },
    "descriptions": {
      "total_revenue": "Revenus totaux de toutes les sources",
      "total_expenses": "Coûts totaux de toutes les catégories",
      "net_profit_kpi": "Revenus moins toutes les dépenses",
      "orders_kpi": "Nombre total de commandes",
      "ad_spend_kpi": "Total des dépenses publicitaires",
      "aov_kpi": "Revenu moyen par commande",
      "net_profit_over_time": "Profit quotidien après tous les coûts",
      "profit_waterfall": "Décomposition étape par étape du CA brut au bénéfice net",
      "profit_margin_over_time": "Tendance quotidienne du pourcentage de marge",
      "income_vs_costs": "Ligne de revenus vs catégories de dépenses empilées",
      "daily_pl_table": "Détail jour par jour des profits et pertes",
      "running_profit": "Profit cumulé sur la période",
      "profit_period_comparison": "Tendance du profit comparée à la période précédente",
      "roas_by_platform": "Retour sur dépense pub par plateforme",
      "roas_over_time": "Tendance quotidienne du retour sur dépense pub",
      "blended_mer": "Revenu total divisé par la dépense pub totale",
      "ad_spend_percent": "Quelle part du CA va à la publicité",
      "cpa_over_time": "Coût quotidien d'acquisition d'une commande",
      "campaign_roas_leaderboard": "Campagnes classées par ROAS",
      "ad_set_efficiency_scatter": "Dépense vs revenu par ensemble pub",
      "creative_performance_table": "Métriques par publicité : dépense, impressions, clics, CTR, CPC, ROAS",
      "ad_funnel": "Entonnoir de conversion des impressions aux achats",
      "cpm_trend": "Coût quotidien pour 1 000 impressions",
      "cpc_trend": "Coût moyen quotidien par clic",
      "wasted_ad_spend": "Publicités avec dépense mais zéro conversion",
      "ctr_over_time": "Tendance quotidienne du CTR",
      "best_sellers_by_revenue": "Produits classés par revenu total",
      "revenue_concentration": "Analyse Pareto du revenu produit",
      "product_sales_trend": "Revenu par produit dans le temps",
      "units_sold_ranking": "Produits classés par quantité vendue",
      "revenue_per_unit": "Prix de vente moyen par unité",
      "product_return_rate": "Quels produits sont le plus retournés",
      "refund_damage_by_product": "Produits coûtant le plus en remboursements",
      "product_channel_matrix": "Carte de chaleur : produits vs canaux de vente",
      "expense_category_donut": "Répartition proportionnelle de tous les coûts",
      "expense_category_trend": "Chaque type de coût empilé dans le temps",
      "payment_processing_fees": "Frais Shopify et passerelle de paiement",
      "payment_fees_percent": "Part des frais de traitement par rapport au CA",
      "shipping_cost_over_time": "Revenus quotidiens d'expédition",
      "shipping_per_order": "Tendance du revenu d'expédition par commande",
      "discount_total_and_rate": "Montants et pourcentage des remises",
      "journal_expense_breakdown": "Dépenses manuelles par catégorie",
      "journal_expenses_over_time": "Tendance des dépenses journal et formules",
      "true_cost_per_order": "Coût tout compris par commande",
      "expense_anomaly_detector": "Jours avec des coûts anormalement élevés",
      "daily_inflows_outflows": "Barres de revenus vs dépenses par jour",
      "cumulative_cash_position": "Net cumulé depuis le jour 1 de la période",
      "ad_spend_vs_revenue_timing": "Décalage de trésorerie entre dépense et encaissement",
      "weekly_cash_summary": "Total entrées, sorties et net par semaine",
      "break_even_day": "Quand le CA cumulé a dépassé les dépenses cumulées",
      "money_flow_sankey": "Sources de revenus vers catégories de dépenses vers bénéfice net",
      "return_rate_over_time": "Pourcentage quotidien de commandes retournées",
      "refund_amount_over_time": "Total quotidien des remboursements",
      "refund_type_breakdown": "Retours complets vs partiels vs expédition",
      "refund_true_cost": "Montant remboursé plus dépense pub gaspillée",
      "most_returned_products": "Produits avec les montants de remboursement les plus élevés",
      "paid_vs_organic_revenue": "Répartition entre pub payante et trafic organique",
      "paid_vs_organic_trend": "Revenus quotidiens payants et organiques",
      "revenue_by_utm_source": "Quelles sources de trafic génèrent du CA",
      "revenue_by_utm_campaign": "Revenu par campagne UTM",
      "unattributed_revenue": "Revenus sans source de trafic",
      "purchase_frequency": "Distribution du nombre de commandes par client",
      "top_customers_by_revenue": "Clients ayant le plus dépensé",
      "customer_concentration": "Répartition du CA entre les clients",
      "new_vs_returning_revenue": "Revenus des primo-acheteurs vs récurrents",
      "avg_revenue_per_customer": "Revenu total divisé par les clients uniques",
      "revenue_period_comparison": "CA quotidien comparé à la période précédente",
      "order_volume_over_time": "Tendance quotidienne du nombre de commandes",
      "aov_trend": "Tendance quotidienne du panier moyen",
      "revenue_vs_ad_spend_growth": "Le CA dépasse-t-il la dépense pub ?",
      "spend_vs_roas_scatter": "Dépenser plus fonctionne-t-il encore ?",
      "sales_by_day_of_week": "Quand vos clients achètent-ils ?",
      "revenue_forecast": "CA projeté basé sur les tendances",
      "expense_forecast": "Projection des coûts futurs",
      "profit_forecast": "Projections combinées revenus et dépenses",
      "break_even_projection": "Quand le profit cumulé deviendra-t-il positif ?",
      "seasonal_index": "Quels jours sur/sous-performent régulièrement",
      "what_if_simulator": "Simuler l'impact de changements de budget pub",
      "activity_timeline": "Tous les changements pub et produits, colorés par type",
      "revenue_with_action_markers": "CA quotidien avec annotations d'événements",
      "budget_change_impact": "CA avant vs après les changements de budget",
      "budget_increase_efficiency": "ROAS incrémental sur les hausses de budget",
      "campaign_toggle_impact": "CA avant vs après changements de statut",
      "pause_resume_comparison": "Performance pré-pause vs post-reprise",
      "creative_swap_performance": "CTR avant vs après changement de créative",
      "audience_change_impact": "CPM avant vs après changement de ciblage",
      "ad_approval_tracker": "Publicités approuvées vs rejetées",
      "campaign_lifecycle": "Chronologie complète par campagne",
      "product_launch_performance": "CA des produits nouvellement publiés",
      "product_removal_impact": "Impact sur le CA du retrait de produits",
      "promo_discount_rule_impact": "Volume de commandes avant vs après les changements de promo",
      "refund_spike_analysis": "Commandes vs remboursements décalés par délai de livraison",
      "order_fulfillment_funnel": "Passées, confirmées, expédiées",
      "cancellation_rate_over_time": "Pourcentage quotidien de commandes annulées",
      "activity_volume_vs_revenue": "Plus de changements = meilleurs résultats ?",
      "billing_issues_timeline": "Événements de facturation et échecs des plateformes pub",
      "action_breakdown_by_type": "Nombre de changements par catégorie",
      "before_after_any_action": "Impact agrégé sur le CA de toutes les actions"
    },
    "components": {
      "week_number": "Semaine {{number}}",
      "weeks": "Semaines",
      "months": "Mois",
      "net_cash_flow": "Flux de trésorerie net",
      "selected_items": "Éléments sélectionnés",
      "channels": "Canaux",
      "items": "Éléments",
      "journals": "Journaux",
      "specs": "Calculs",
      "all": "Tous",
      "periodTotalCaps": "TOTAL PÉRIODE",
      "totalCaps": "TOTAL",
      "categoriesHeading": "Catégories",
      "ads": "Pubs",
      "sales": "Ventes",
      "moneyJournals": "Journaux de Caisse",
      "moneyJournal": "Journal de Caisse",
      "boardSpecs": "Specs du Tableau",
      "boardSpec": "Spec du Tableau",
      "channel": "Canal",
      "connection": "Connexion",
    "noData": {
      "title": "Aucune donnée disponible",
      "description": "Nous n'avons trouvé aucun enregistrement pour cette analyse spécifique."
    },
      "noTransactionData": "Aucune donnée disponible",
      "aboutThisChart": "À propos de ce graphique",
      "noCategoryData": "Aucune donnée de catégorie disponible",
      "noRevenueData": "Aucune donnée de revenu disponible",
      "noFinancialData": "Aucune donnée financière disponible",
      "noEventsRecorded": "Aucun événement enregistré",
      "eventsWillAppear": "Les événements apparaîtront ici une fois qu'ils se produiront",
      "netProfit": "Bénéfice Net",
      "netCashFlow": "Flux de Trésorerie Net",
      "marketing": "Marketing",
      "cogs": "COGS",
      "fees": "Frais",
      "runningTotal": "Total Cumulé",
      "opex": "OpEx",
      "cashflowWaterfall": "Répartition de Trésorerie",
      "profitMargin": "Marge de Profit",
      "revenue": "Revenu",
      "expenses": "Dépenses",
      "net": "Net",
      "account": "Compte",
      "returns": "Retours",
      "grossSales": "Ventes Brutes",
      "totalRevenue": "Revenu Total",
      "totalExpenses": "Dépenses Totales",
      "running": "Courant",
      "discounts": "Remises",
      "netSales": "Ventes Nettes",
      "shipping": "Revenus d'expédition",
      "shippingPerOrder": "Revenu expédition/commande",
      "taxes": "Taxes",
      "less": "Moins",
      "more": "Plus",
      "total": "Total",
      "avgPerDay": "Moy/Jour",
      "transactions": "Enregistrements",
      "cumulative": "Cumulatif",
      "overallAverage": "Moyenne Globale",
      "avgRevenue": "Revenu Moyen",
      "avgExpense": "Dépense Moyenne",
      "acrossTransactions": "sur {{count}} enregistrements",
      "revenueAvgComparison": "Le revenu moyen est de {{percent}}% de la dépense moyenne",
      "discountsApplied": "Remises Appliquées",
      "netAfterDiscounts": "Net Après Remises",
      "revenueRetention": "Rétention des Revenus",
      "discountRate": "Taux de Remise",
      "comparisonOverview": "Comparaison globale",
      "detailedAnalysis": "Analyse détaillée des revenus et dépenses",
      "adjustments": "Ajustements",
      "totalSales": "Ventes Totales",
      "visualizeFlow": "Visualisez comment l'argent circule dans votre entreprise",
      "percentOfGrossSales": "{{percent}}% du chiffre d'affaires brut",
      "unknown": "Inconnu",
      "profit": "Profit",
      "roasLabel": "Retour sur Dépenses Publicitaires (ROAS)",
      "generatedPerDollar": "Revenus générés par dollar dépensé",
      "adSpend": "Dépenses Pub",
      "roasFooter": "Pour chaque {{symbol}}1 dépensé en publicité, vous générez {{symbol}}{{value}} de revenus",
      "noAdvertisingData": "Aucune donnée publicitaire",
      "addAdSpend": "Ajoutez des données de dépenses pub pour calculer le ROAS",
      "reporting": {
        "advertising": "Publicité",
        "marketing": "Marketing",
        "platformFees": "Frais de Plateforme",
        "paymentFees": "Frais de Paiement",
        "otherExpenses": "Autres Dépenses"
      },
      "noExpenseData": "Aucune donnée de dépense",
      "expensesAppearOnceAvailable": "Les dépenses apparaîtront ici une fois disponibles",
      "dailyCumulativeTrends": "Tendances cumulatives quotidiennes",
      "financialFlowWithMarkers": "Flux financier avec marqueurs d'événements",
      "netFlow": "Flux Net",
      "eventCount": "Nombre d'Événements",
      "eventImpactFooter": "Les barres violettes indiquent l'activité des événements. Survolez-les pour voir les détails et leur impact sur la trésorerie.",
      "status": {
        "excellent": "Excellent",
        "good": "Bon",
        "moderate": "Modéré",
        "high": "Élevé",
        "breakEven": "Équilibre",
        "poor": "Médiocre"
      },
      "source": {
        "manual": "Saisie Manuelle",
        "unknown": "Inconnu"
      },
      "unableToDisplay": "Impossible d'afficher le graphique",
      "chartLoadError": "Ce graphique n'a pas pu être chargé. Veuillez essayer de rafraîchir la page.",
      "reloadPage": "Recharger la page",
      "removeChart": "Supprimer le graphique",
      "cohort": "Cohorte",
      "monthN": "Mois {{n}}",
      "cohortFooter": "Les couleurs plus foncées indiquent des revenus plus élevés. Suivez comment les cohortes de clients génèrent des revenus dans le temps.",
      "before": "Avant",
      "during": "Pendant",
      "after": "Après",
      "addEventsForROI": "Ajoutez des événements pour calculer le ROI",
      "addEventsForAnalysis": "Ajoutez des événements pour analyser l'impact sur les revenus",
      "sunday": "Dimanche",
      "monday": "Lundi",
      "tuesday": "Mardi",
      "wednesday": "Mercredi",
      "thursday": "Jeudi",
      "friday": "Vendredi",
      "saturday": "Samedi",
      "bestDay": "Meilleur Jour",
      "worstDay": "Jour le Plus Faible",
      "noMarketingData": "Aucune donnée marketing disponible",
      "addMarketingExpenses": "Ajoutez des dépenses marketing ou publicitaires pour suivre le CAC",
      "avgCAC": "CAC Moyen",
      "newCustomers": "Nouveaux Clients",
      "avgMargin": "Marge Moy.",
      "marginDropsDetected": "{{count}} baisses de marge significatives détectées",
      "weeklyTrend": "Tendance Hebdomadaire",
      "velocityExplainer": "Moyenne mobile sur 7 jours des revenus quotidiens",
      "eventMarkers": "Marqueurs d'événements",
      "dailyAvgRevenue": "Revenu Quotidien Moyen",
      "anomaliesDetected": "anomalies détectées",
      "normal": "Normal",
      "anomaly": "Anomalie",
      "average": "Moyenne",
      "noPromotionEvents": "Aucun événement promotionnel enregistré",
      "addPromotionEvents": "Ajoutez des événements de promotion ou de campagne pour analyser leur efficacité",
      "revenueLift": "Hausse des Revenus",
      "promotionFooter": "Compare le revenu quotidien moyen avant et après chaque promotion",
      "breakEvenReached": "Seuil de rentabilité atteint",
      "projectedBreakEven": "Seuil de rentabilité projeté",
      "notYetBreakEven": "Pas encore au seuil de rentabilité",
      "cumulativeRevenue": "Revenu Cumulé",
      "cumulativeExpenses": "Dépenses Cumulées",
      "netPosition": "Position Nette",
      "attributionFooter": "Revenus attribués à chaque canal selon la source des données",
      "insufficientData": "Données insuffisantes pour la prévision",
      "needMoreHistory": "Au moins 2 semaines d'historique de dépenses requises",
      "trendIncreasing": "Dépenses en hausse",
      "trendDecreasing": "Dépenses en baisse",
      "trendStable": "Dépenses stables",
      "actual": "Réel",
      "forecast": "Prévision",
      "upper": "Supérieur",
      "lower": "Inférieur",
      "topEventType": "Type d'Événement Principal",
      "avgRevenuePerEvent": "Revenu Moy. par Événement",
      "revenuePerEventFooter": "Revenu moyen dans les 3 jours suivant chaque type d'événement",
      "lift": "Hausse",
      "drop": "Baisse",
      "noChange": "Pas de changement",
      "impactByActionType": "Impact par type d'action",
      "averageLift": "Hausse moyenne",
      "metricCTR": "CTR",
      "metricCPC": "CPC",
      "metricROAS": "ROAS",
      "metricRevenue": "Revenu",
      "metricOrders": "Commandes",
      "metricProfit": "Profit",
      "margin": "Marge",
      "forecastedGrowth": "Croissance prévue",
      "need14Days": "Au moins 14 jours de données requis",
      "need21Days": "Au moins 21 jours de données requis",
      "needMonthlyData": "Au moins 2 mois de données requis",
      "next14Days": "14 prochains jours",
      "expected": "Attendu",
      "worstCase": "Pire cas",
      "bestCase": "Meilleur cas",
      "confidence": "Confiance",
      "simulationCount": "{{count}} simulations",
      "both": "Les deux",
      "linear": "Linéaire",
      "polynomial": "Polynomial",
      "bestFit": "Meilleur ajustement",
      "regressionExplainer": "Un R² plus élevé indique un meilleur ajustement. Les lignes pointillées montrent les prévisions.",
      "trend": "Tendance",
      "seasonal": "Saisonnier",
      "residual": "Résiduel",
      "trendChange": "Changement de tendance",
      "seasonalVariation": "Variation saisonnière",
      "seasonalIndex": "Indice Saisonnier",
      "seasonalIndexExplainer": "Les barres au-dessus de 0% indiquent des jours supérieurs à la moyenne, en dessous indique inférieurs.",
      "monthlyGrowth": "Croissance Mensuelle",
      "expenseRatio": "Ratio de Dépenses",
      "projectedRevenue6M": "Revenus 6M",
      "projectedProfit6M": "Profit 6M",
      "anomaliesFound": "anomalies détectées",
      "baseline": "Référence",
      "zScoreThreshold": "Seuil Z-Score",
      "accuracy": "Précision",
      "strong": "Forte",
      "weak": "Faible",
      "low": "Basse",
      "grossRevenue": "Revenu Brut",
      "erosion": "Érosion",
      "netContribution": "Contribution Nette",
      "shippingLogistics": "Livraison & Logistique",
      "taxCompliance": "Taxes & Conformité",
      "totalCommercialVolume": "Volume Commercial Total",
      "growth": "Croissance",
      "sector": "Secteur",
      "noSectorData": "Aucune donnée sectorielle disponible",
      "economicsRatio": "Ratio de l'Économie d'Unité",
      "healthStatus": "Statut de Santé",
      "efficientGrowth": "Croissance Efficace",
      "highAcquisitionCost": "Coût d'Acquisition Élevé",
      "costToAcquire": "Coût d'Acquisition",
      "ltvEst": "Valeur Vie (Est.)",
      "estimatedRunway": "Runway Estimé",
      "riskLevel": "Niveau de Risque",
      "healthy": "SAIN",
      "critical": "CRITIQUE",
      "solvencyDisclaimer": "* Basé sur le taux de brûlage mensuel actuel. Ne prend pas en compte les investissements futurs ou la saisonnalité.",
      "marginIntegrityMap": "Carte d'Intégrité des Marges",
      "leakageHighlight": "Mise en évidence des événements d'érosion à fort impact (retours & remises)",
      "volume": "Volume",
      "leakage": "Fuite",
      "highRisk": "Risque Élevé",
      "moderate": "Modéré",
      "sizeIndicatesLeakage": "La taille indique l'ampleur de la fuite",
      "productAffinityHeatmap": "Carte d'Affinité Produit",
      "affinityScore": "Score d'Affinité",
      "clusteringExplainer": "Probabilité que les articles soient achetés ensemble",
      "insufficientDataSolvency": "Données insuffisantes pour la projection de solvabilité.",
      "anomalies": "Anomalies",
      "weightedCAC": "Weighted CAC",
      "cacLimit": "CAC Limit",
      "forecastAccuracy": "Forecast Accuracy",
      "attributionModel": "Attribution Model",
      "event": "Événement",
      "week": "Semaine",
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mer",
      "thu": "Jeu",
      "fri": "Ven",
      "sat": "Sam",
      "sun": "Dim",
      "Variable Costs": "Coûts Variables",
      "Contribution Margin": "Marge de Contribution",
      "cumulativePct": "% Cumulé",
      "revenuePct": "% Revenu",
      "refunds": "Remboursements",
      "avgLTV": "LTV Moy.",
      "revIndex": "Indice de Revenu",
      "fixedIndex": "Indice de Coûts Fixes",
      "mer": "MER",
      "grossProfit": "Gross Profit",
      "contributionMargin": "Contribution Margin",
      "opEx": "Operating Expenses",
      "ebitda": "EBITDA"
    },
    "empty": {
      "title": "Aucun graphique dans cette catégorie pour l'instant",
      "subtitle": "Nous travaillons sur l'ajout de nouveaux graphiques !"
    },
    "syncInfo": "Les graphiques se synchronisent automatiquement avec vos données.",
    "searchPlaceholder": "Rechercher des graphiques...",
    "dragToAdd": "Glisser pour ajouter",
    "transactionCategories": {
      "partial_return": "Partial Return",
      "product_return": "Product Return",
      "shipping_refund": "Shipping Refund",
      "tax_refund": "Tax Refund"
    }
  },
  "templates": {
    "title": "Modèles",
    "subtitle": "Choisissez un modèle pour configurer rapidement votre page de tableau.",
    "emptyPage": "Page Vide",
    "emptyPageDescription": "Commencez avec une toile vierge",
    "categories": {
      "all": "Tous",
      "financialInsights": "Insights Financiers",
      "decisionSupport": "Aide à la Décision",
      "operationalEfficiency": "Efficacité Opérationnelle",
      "customerBehavior": "Comportement Client",
      "predictiveAnalytics": "Analyse Prédictive",
      "riskManagement": "Gestion des Risques",
      "other": "Autre"
    },
    "empty": {
      "title": "Aucun modèle dans cette catégorie",
      "subtitle": "Créez votre premier modèle ou essayez une autre catégorie."
    },
    "import": {
      "title": "Importer un Modèle",
      "dropHere": "Déposez le fichier de modèle ici",
      "clickToImport": "Cliquez pour importer ou déposez un fichier",
      "supportedFormats": "Supporte les fichiers .json"
    },
    "templateType": "Type de modèle",
    "selectType": "Sélectionner un type",
    "selectPageTypeTitle": "Sélectionner le Type de Page",
    "pageTypes": {
      "performance": "Performance",
      "performanceDescription": "Analysez et visualisez vos métriques de performance commerciale.",
      "forecast": "Prévisions",
      "forecastDescription": "Prédisez vos revenus et dépenses futurs à l'aide de données historiques.",
      "cashflow": "Trésorerie",
      "cashflowDescription": "Surveillez l'argent entrant et sortant de votre entreprise.",
      "composer": "Composeur",
      "composerDescription": "Construisez des vues personnalisées avec des composants spécialisés.",
      "traffic": "Trafic",
      "trafficDescription": "Analysez la répartition et le flux de trésorerie de vos sources de trafic."
    }
  },
  "connections": {
    "title": "Connexions",
    "addConnection": "Ajouter une connexion",
    "connected": "Connecté",
    "disconnected": "Déconnecté",
    "connect": "Connecter",
    "disconnect": "Déconnecter",
    "testConnection": "Tester la connexion",
    "connectionStatus": "Statut de la connexion",
    "syncNow": "Synchroniser maintenant",
    "active": "Actif",
    "syncing": "Synchronisation"
  },
  "channels": {
    "shopify": "Shopify",
    "meta": "Meta",
    "tiktok": "TikTok",
    "google": "Google",
    "woocommerce": "WooCommerce",
    "amazon": "Amazon",
    "channels": "Canaux",
    "active": "Actif",
    "inactive": "Inactif",
    "uninstalled": "Désinstallé",
    "partial": "Partiel",
    "removeChannel": "Supprimer le canal",
    "noElements": "Aucun élément disponible",
    "noChannels": "Aucun canal ajouté",
    "addChannel": "Ajouter un canal",
    "loadingChannels": "Chargement des canaux...",
    "connect": "Connecter",
    "connectChannel": "Connecter un canal",
    "choosePlatform": "Choisissez une plateforme à connecter et commencez à importer vos données",
    "backToChannels": "Retour aux canaux",
    "connectShopify": "Connecter à Shopify",
    "shopifyIntro": "Connectez votre boutique Shopify en installant notre application officielle. Cela garantit une synchronisation sécurisée et automatisée de vos commandes et analyses.",
    "shopifyStage1": "Cliquez sur 'Installer l'application Dashbal' ci-dessous pour commencer.",
    "shopifyStage2": "Connectez-vous à votre boutique Shopify et approuvez les autorisations.",
    "shopifyStage3": "Détendez-vous pendant que nous synchronisons vos données pour la première fois !",
    "installDashbalApp": "Installer l'application Dashbal",
    "connectWooCommerce": "Connecter à WooCommerce",
    "wooIntro": "Connectez votre boutique WooCommerce en installant notre plugin WordPress dédié. Cela nous permet de synchroniser vos commandes et données de vente en toute sécurité.",
    "wooStep1": "Téléchargez le plugin Dashbal Connector à l'aide du bouton ci-dessous.",
    "wooStep2": "Allez dans Extensions > Ajouter > Téléverser sur votre tableau de bord WordPress.",
    "wooStep3": "Activez le plugin et cliquez sur 'Connecter à Dashbal' pour finaliser.",
    "downloadPlugin": "Télécharger le plugin Dashbal",
    "goToWooAdmin": "Aller aux réglages API WooCommerce",
    "fillAllFields": "Veuillez remplir tous les champs",
    "connectStore": "Connecter la boutique",
    "shopifyRelease1": "Saisissez l'URL de votre boutique Shopify",
    "shopifyRelease2": "Installez l'application Dashbal dans votre administration Shopify",
    "shopifyRelease3": "Cliquez sur \"Connecter à Dashbal\" dans l'application",
    "verifyingStore": "Vérification de la boutique...",
    "goToShopifyAdmin": "Aller à l'administration Shopify",
    "connectingTo": "Connexion à {{channel}}",
    "completeAuthorization": "Veuillez compléter l'autorisation dans la fenêtre popup. Cela peut prendre un moment...",
    "loadingChannelsModal": "Chargement des canaux disponibles...",
    "noChannelsAvailable": "Aucun canal disponible",
    "contactSupport": "Veuillez contacter le support pour activer les canaux pour votre compte.",
    "availablePlatforms": "Plateformes disponibles",
    "clickToConnect": "Cliquez sur une plateforme pour commencer le processus de connexion",
    "dataSecure": "Vos données sont chiffrées et sécurisées",
    "cancel": "Annuler",
    "connecting": "Connexion...",
    "enterShopUrlPlaceholder": "votre-boutique.myshopify.com",
    "shopUrlHelper": "Vous pouvez également entrer votre domaine personnalisé ou juste le sous-domaine (ex. \"maboutique\")",
    "popupBlocked": "La popup a été bloquée. Veuillez autoriser les popups pour ce site.",
    "failedToSync": "Nous n'avons pas pu synchroniser vos données",
    "disconnected": "Déconnecté",
    "reconnect": "Reconnecter",
    "status": "Statut",
    "reloadInitiated": "Actualisation lancée. Les données sont en cours de récupération.",
    "reloadFailed": "Échec du lancement de l'actualisation.",
    "failedToConnect": "Échec de la connexion du canal",
    "oauthFailed": "Nous n'avons pas pu nous connecter à votre compte",
    "myChannels": "Mes canaux",
    "selectOrAddChannel": "Sélectionnez un canal connecté ou ajoutez-en un nouveau",
    "noChannelsYet": "Aucun canal pour l'instant",
    "getStartedDescription": "Commencez par connecter votre premier canal. Cliquez sur le bouton ci-dessous pour ajouter un canal.",
    "addFirstChannel": "Ajouter votre premier canal",
    "channel": "Canal",
    "provideRequiredInfo": "Veuillez fournir les informations requises pour vous connecter",
    "deleteChannel": "Supprimer le canal",
    "syncing": "Synchronisation...",
    "error": "Erreur",
    "loadingEntities": "Chargement des éléments...",
    "loadingCampaigns": "Chargement de vos campagnes...",
    "loadingCampaignsHint": "Nous récupérons les détails de votre compte. Cela peut prendre un moment.",
    "loadingItems": "Chargement des éléments...",
    "noEntitiesFound": "Aucun élément trouvé",
    "noItemsFound": "Aucun élément trouvé",
    "selectParentHint": "Sélectionnez un parent dans l'onglet précédent",
    "retrySync": "Réessayer la synchronisation",
    "addedAt": "Connecté le",
    "situation": "Situation Actuelle",
    "actions": "Actions",
    "information": "Informations",
    "whatToDo": "À quoi sert ce canal ?",
    "whatToDoDescription": "Liez cette source à vos tableaux pour commencer à suivre ses résultats. Vous pouvez sélectionner des éléments spécifiques à inclure dans votre analyse financière et développer votre entreprise grâce aux données.",
    "whatToDoDescription_shopify": "Connectez votre boutique pour importer automatiquement vos ventes, produits et clients. Utilisez ces données pour construire vos tableaux financiers et suivre votre profit réel.",
    "whatToDoDescription_meta": "Connectez votre compte publicitaire pour synchroniser vos dépenses et métriques de performance. Utilisez ces données pour suivre l'efficacité de vos résultats et optimiser votre budget marketing.",
    "whatToDoDescription_tiktok": "Connectez votre gestionnaire de publicités pour synchroniser les dépenses de campagne et les performances. Utilisez ces données pour analyser vos résultats marketing et votre croissance.",
    "whatToDoDescription_google": "Connectez votre compte Google Ads pour synchroniser vos dépenses et métriques de performance. Utilisez ces données pour suivre votre efficacité et optimiser votre budget.",
    "whatToDoDescription_woocommerce": "Connectez votre boutique pour synchroniser vos commandes et produits sur tous vos sites. Utilisez ces informations pour centraliser votre suivi financier.",
    "reload": "Recharger les données",
    "placeholders": {
      "storeUrl": "https://votre-boutique.com",
      "shopifyUrl": "votre-boutique.myshopify.com ou votre-boutique.com",
      "wooConsumerKey": "ck_...",
      "wooConsumerSecret": "cs_..."
    },
    "creditCard": "Credit Card",
    "selectChannel": "Select Channel"
  },
  "actions": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "create": "Créer",
    "addOperation": "Ajouter un enregistrement",
    "update": "Mettre à jour",
    "confirm": "Confirmer",
    "back": "Retour",
    "next": "Suivant",
    "loading": "Chargement...",
    "creating": "Création...",
    "search": "Rechercher",
    "filter": "Filtrer",
    "sort": "Trier",
    "share": "Partager",
    "rename": "Renommer",
    "openMenu": "Ouvrir le menu",
    "close": "Fermer",
    "gotIt": "Compris, merci !",
    "remove": "Remove",
    "removeChannel": "Supprimer le canal",
    "removeJournal": "Supprimer le journal",
    "done": "Terminé",
    "continue": "Quitter le tableau",
    "stay": "Rester",
    "addSelection": "Ajouter la sélection",
    "editing": "Modification",
    "refresh": "Actualiser",
    "adjustDateRange": "Ajuster la plage de dates",
    "discard": "Abandonner",
    "download": "Télécharger",
    "dismissAlert": "Fermer l'alerte",
    "import": "Importer",
    "export": "Exporter",
    "tryAgain": "Réessayer",
    "goHome": "Retour à l'accueil",
    "sending": "Envoi en cours...",
    "reload": "Actualiser",
    "goToDashboard": "Go to Dashboard",
    "deleting": "Deleting..."
  },
  "time": {
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "daysAgo": "il y a {{count}}j",
    "justNow": "À l'instant",
    "minsAgo": "il y a {{count}}m",
    "hoursAgo": "il y a {{count}}h",
    "mon": "Lun",
    "tue": "Mar",
    "wed": "Mer",
    "thu": "Jeu",
    "fri": "Ven",
    "sat": "Sam",
    "sun": "Dim"
  },
  "errors": {
    "required": "Ce champ est obligatoire",
    "invalidEmail": "Veuillez saisir une adresse e-mail valide",
    "passwordTooShort": "Le mot de passe doit contenir au moins 8 caractères",
    "nameTooShort": "Le nom doit contenir au moins 2 caractères",
    "confirmPassword": "Veuillez confirmer votre mot de passe",
    "passwordsDontMatch": "Les mots de passe ne correspondent pas",
    "somethingWentWrong": "Quelque chose s'est mal passé",
    "networkError": "Problème de connexion",
    "unauthorized": "Veuillez vous connecter pour continuer",
    "forbidden": "Vous n'avez pas la permission de voir ceci",
    "failedToLoadBoards": "Échec du chargement des espaces de travail. Veuillez réessayer plus tard.",
    "failedToCreateBoard": "Échec de la création de l'espace de travail",
    "failedToUpdateBoard": "Échec de la mise à jour de l'espace de travail",
    "failedToDeleteBoard": "Échec de la suppression de l'espace de travail",
    "failedToLoadChannel": "Échec du chargement des données du canal",
    "failedToAddChannel": "Échec de l'ajout du canal à l'espace de travail",
    "error": "Erreur",
    "pleaseEnterShopUrl": "Veuillez entrer l'URL de votre boutique",
    "wooConnectFailed": "Échec de la connexion. Veuillez vérifier vos informations d'identification.",
    "wooConnectionError": "Erreur de connexion. Veuillez vérifier vos informations d'identification.",
    "failedToUpdateBoardName": "Échec de la mise à jour du nom du tableau",
    "failedToUpdateEntitySelection": "Failed to update selection, please retry",
    "failedToRemoveChannel": "Failed to remove channel from board",
    "failedToCreateOperation": "Failed to create operation",
    "failedToDeleteOperation": "Failed to delete operation",
    "failedToDeletejournal": "Failed to delete journal",
    "noBoardId": "No board ID available",
    "channel": {
      "30": "Sync error. Please try again.",
      "31": "Source not responding. Please check your connection or the status of the external platform.",
      "32": "Unauthorized access to channel. Please re-authenticate.",
      "33": "Nous avons rencontré un problème lors de la synchronisation de vos données.",
      "34": "Partial data sync. Some information might be missing.",
      "35": "Rate limit exceeded. Please try again later.",
      "36": "Invalid credentials. Please disconnect and reconnect the channel.",
      "37": "Nous avons eu du mal à traiter vos données. Veuillez contacter le support.",
      "38": "Resource not found on external platform."
    },
    "tryLater": "Veuillez réessayer plus tard",
    "connectionIssue": "There was a problem connecting to the server. Please check your internet connection.",
    "timeout": "Server took too long. Please try again.",
    "generic": "An error occurred",
    "failedToUpdateChannelStatus": "Failed to update channel status",
    "failedToUpdateJournalStatus": "Failed to update journal status",
    "failedToDeleteOperations": "Failed to delete operations",
    "failedToUpdateOperationSelection": "Failed to update operation selection. Please try again."
  },
  "userErrors": {
    "generic": {
      "title": "Une erreur s'est produite",
      "message": "Nous avons rencontré un problème lors du traitement de votre demande. Veuillez réessayer.",
      "action": "Réessayer"
    },
    "serviceUnavailable": {
      "title": "Service Temporairement Indisponible",
      "message": "Nous rencontrons des difficultés techniques. Notre équipe y travaille. Veuillez réessayer dans quelques instants.",
      "action": "Réessayer"
    },
    "networkError": {
      "title": "Problème de Connexion",
      "message": "Veuillez vérifier votre connexion Internet et réessayer.",
      "action": "Réessayer"
    },
    "timeout": {
      "title": "Délai d'Attente Dépassé",
      "message": "La demande prend plus de temps que prévu. Veuillez réessayer.",
      "action": "Réessayer"
    },
    "rateLimit": {
      "title": "Trop de Requêtes",
      "message": "Vous avez fait trop de requêtes. Veuillez attendre avant de réessayer.",
      "action": "Attendre et Réessayer"
    },
    "sessionExpired": {
      "title": "Session Expirée",
      "message": "Votre session a expiré. Veuillez vous reconnecter pour continuer.",
      "action": "Se Connecter"
    },
    "accessDenied": {
      "title": "Accès Refusé",
      "message": "Vous n'avez pas la permission d'effectuer cette action.",
      "action": "Retour"
    },
    "notFound": {
      "title": "Non Trouvé",
      "message": "L'élément demandé n'a pas pu être trouvé.",
      "action": "Retour"
    },
    "validation": {
      "title": "Saisie Invalide",
      "message": "Veuillez vérifier vos informations et réessayer.",
      "action": "Vérifier"
    },
    "auth": {
      "invalidCredentials": "E-mail ou mot de passe invalide. Veuillez vérifier vos identifiants.",
      "accountNotFound": "Compte non trouvé. Veuillez vérifier votre e-mail ou vous inscrire.",
      "accountInactive": "Accès refusé. Votre compte peut être inactif.",
      "emailAlreadyExists": "Cet e-mail est déjà enregistré. Veuillez vous connecter ou utiliser un autre e-mail.",
      "unableToSignIn": "Impossible de se connecter. Veuillez réessayer.",
      "unableToRegister": "Impossible de créer votre compte. Veuillez réessayer.",
      "registrationAgreement": "En vous inscrivant, vous acceptez nos <0>Conditions d'utilisation</0> et notre <1>Politique de confidentialité</1>."
    },
    "boards": {
      "unableToCreate": "Impossible de créer votre espace de travail. Veuillez réessayer.",
      "unableToUpdate": "Impossible d'enregistrer vos modifications. Veuillez réessayer.",
      "unableToDelete": "Impossible de supprimer l'espace de travail. Veuillez réessayer.",
      "unableToLoad": "Impossible de charger vos espaces de travail. Veuillez actualiser la page.",
      "unableToRename": "Impossible de renommer l'espace de travail. Veuillez réessayer."
    },
    "channels": {
      "unableToConnect": "Impossible de se connecter à ce canal. Veuillez réessayer.",
      "unableToDisconnect": "Impossible de déconnecter le canal. Veuillez réessayer.",
      "unableToLoad": "Impossible de charger les canaux. Veuillez réessayer.",
      "unableToSync": "Impossible de synchroniser le canal. Veuillez réessayer.",
      "unableToDelete": "Impossible de supprimer le canal. Veuillez réessayer.",
      "unableToRemove": "Impossible de retirer le canal. Veuillez réessayer."
    },
    "journals": {
      "unableToCreate": "Impossible de créer votre journal. Veuillez réessayer.",
      "unableToUpdate": "Impossible d'enregistrer votre journal. Veuillez réessayer.",
      "unableToDelete": "Impossible de supprimer le journal. Veuillez réessayer.",
      "unableToLoad": "Impossible de charger les journaux. Veuillez réessayer.",
      "unableToRemove": "Impossible de retirer le journal. Veuillez réessayer."
    },
    "operations": {
      "unableToCreate": "Impossible de créer l'opération. Veuillez réessayer.",
      "unableToUpdate": "Impossible de mettre à jour l'opération. Veuillez réessayer.",
      "unableToDelete": "Impossible de supprimer l'opération. Veuillez réessayer."
    },
    "profile": {
      "unableToUpdate": "Impossible de mettre à jour le profil. Veuillez réessayer.",
      "emailInUse": "Cet e-mail est déjà utilisé. Veuillez utiliser un autre e-mail.",
      "nameRequired": "Le nom est obligatoire",
      "checkInfo": "Veuillez vérifier vos informations et réessayer.",
      "failedToDeleteAccount": "Failed to delete account. Please try again later."
    },
    "subscription": {
      "unableToLoadPlans": "Impossible de charger les forfaits. Veuillez réessayer.",
      "unableToCheckout": "Impossible de procéder au paiement. Veuillez réessayer.",
      "currencyLocked": "Ce forfait n'est pas disponible dans votre devise de facturation existante. Veuillez contacter le support pour changer.",
      "unableToStartSetup": "Impossible de démarrer la configuration du paiement",
      "failedToRemovePaymentMethod": "Échec du retrait du mode de paiement",
      "failedToUpdateAddress": "Échec de la mise à jour de l'adresse",
      "failedToCancelSubscription": "Échec de l'annulation de l'abonnement",
      "failedToResumeSubscription": "Échec de la reprise de l'abonnement"
    },
    "pages": {
      "unableToCreate": "Impossible de créer la page. Veuillez réessayer.",
      "unableToUpdate": "Impossible de renommer la page. Veuillez réessayer.",
      "unableToDelete": "Impossible de supprimer la page. Veuillez réessayer.",
      "unableToReorder": "Impossible de réorganiser les pages. Veuillez réessayer."
    }
  },
  "success": {
    "boardCreated": "Espace de travail créé avec succès",
    "boardUpdated": "Espace de travail mis à jour avec succès",
    "boardDeleted": "Espace de travail supprimé avec succès",
    "boardRenamed": "Espace de travail renommé avec succès",
    "connectionAdded": "Connexion ajoutée avec succès",
    "connectionRemoved": "Connexion supprimée avec succès",
    "channelConnected": "Canal connecté avec succès !"
  },
  "landing": {
    "heroBadge": "Stoppez les fuites. Gardez le profit.",
    "heroTitle": "Votre Shopify dit que vous êtes rentable. Votre compte bancaire en est moins sûr.",
    "heroSubtitle": "Dashbal récupère chaque coût réel — les retours, les frais de plateforme, le COGS, les abonnements SaaS oubliés — et les soustrait de vos ventes. Ce qui reste est le seul chiffre qui arrive vraiment sur votre compte en banque.",
    "copyright": "© 2026 Dashbal. Tous droits réservés.",
    "cta": {
      "startFree": "Commencer gratuitement",
      "howItWorks": "Montrez-moi comment ça marche",
      "noCard": "Votre vrai chiffre en 2 minutes · Gratuit · Sans carte",
      "bookDemo": "Réserver une démo"
    },
    "nav": {
      "menu": "Ouvrir le menu",
      "product": "Produit",
      "solutions": "Solutions",
      "resources": "Ressources",
      "pricing": "Tarifs",
      "solutionsTestDesc": "Seuil de rentabilité par produit et signaux kill/scale quand vous testez vos gagnants.",
      "solutionsScaleDesc": "ROAS mélangé, CAC réel et prévision de trésorerie 30 jours pour les boutiques en croissance.",
      "solutionsScaleDescNoForecast": "ROAS mélangé, CAC réel et suivi de trésorerie en temps réel pour les boutiques en croissance.",
      "solutionsBrandDesc": "Métriques personnalisées, tableaux multi-devises et partage d'équipe pour les marques établies.",
      "resourcesHowTitle": "Comment ça marche",
      "resourcesHowDesc": "De l'inscription au premier chiffre de profit, en moins de dix minutes.",
      "resourcesIntegrationsTitle": "Intégrations",
      "resourcesIntegrationsDesc": "Boutiques et plateformes publicitaires compatibles avec Dashbal nativement.",
      "resourcesFaqTitle": "FAQ",
      "resourcesFaqDesc": "Réponses rapides aux questions que l'on nous pose le plus.",
      "resourcesDemoTitle": "Réserver une démo",
      "resourcesDemoDesc": "Découvrez Dashbal avec notre équipe lors d'un appel de 30 minutes."
    },
    "pain": {
      "eyebrow": "Ça vous parle ?",
      "1": "Shopify dit que vous avez encaissé 40 000 $ ce mois-ci. Votre compte bancaire raconte une autre histoire.",
      "2": "Meta jure que votre ROAS est de 4. Après les retours, les frais et le COGS, il est à peine à 1,4.",
      "3": "La feuille de calcul tenait — jusqu'à ce que vous activiez TikTok. Maintenant les formules ne tombent plus juste.",
      "4": "Le temps que vous clôturiez le mois, la mauvaise semaine est déjà devenue un mauvais mois."
    },
    "how": {
      "eyebrow": "Mise en place",
      "title": "Dix minutes de l'inscription à votre premier chiffre honnête.",
      "subtitle": "Pas d'export CSV. Pas d'appel d'intégration. Pas d'analyste à honoraires.",
      "step1Title": "Branchez ce que vous utilisez déjà",
      "step1Desc": "Un clic pour Shopify et WooCommerce. Une seule connexion pour Meta, TikTok et Google. Vos 60 à 180 derniers jours apparaissent avant que votre café ne refroidisse.",
      "step1Detail": "Chaque nouvelle vente, retour ou changement de dépense pub arrive en quelques secondes — pas du jour au lendemain.",
      "step2Title": "Ajoutez les coûts que personne d'autre ne suit",
      "step2Desc": "COGS, TVA, frais de paiement, l'abonnement entrepôt, les SaaS oubliés. Photographiez un reçu — l'IA lit les lignes et les classe. Ponctuel ou récurrent, rattaché à ce qui les concerne.",
      "step2Detail": "Multi-devises. Rattachez à un canal, un produit ou tout votre P&L.",
      "step3Title": "Voyez ce qui a vraiment atterri sur le compte",
      "step3Desc": "Le vrai profit net par canal, produit et publicité — pas la version que Meta veut vous montrer. Mises à jour quotidiennes, prévisions à 30 jours, explications en clair de ce qui a changé.",
      "step3DescNoForecast": "Le vrai profit net par canal, produit et publicité — pas la version que Meta veut vous montrer. Mises à jour quotidiennes, suivi de trésorerie, explications en clair de ce qui a changé.",
      "step3Detail": "Construisez le tableau que votre comptable construirait, ou partez d'un qui pense déjà comme lui."
    },
    "feature": {
      "eyebrow": "À l'intérieur",
      "title": "Six outils que vous étiez presque en train de bricoler vous-même dans un tableur.",
      "titleFive": "Cinq outils que vous étiez presque en train de bricoler vous-même dans un tableur.",
      "subtitle": "Un seul onglet. Arrêtez de jongler entre Shopify, Meta, TikTok et une feuille pas mise à jour depuis mardi.",
      "channelsTitle": "Tous les canaux, avant que votre café ne refroidisse",
      "channelsDesc": "Shopify, Meta, TikTok, WooCommerce — connectés une fois, rapprochés en continu. Commandes, dépenses pub, retours et frais arrivent à leur place, au moment où ils se produisent.",
      "journalsTitle": "Les coûts qu'aucune plateforme ne vous montre",
      "journalsDesc": "COGS, TVA, frais de paiement, vos 400 $/mois de SaaS, l'abonnement entrepôt. Photographiez un reçu — l'IA en extrait les lignes. Récurrent ou ponctuel, rattaché à ce qui le concerne.",
      "formulasTitle": "Les métriques de votre comptable, construites une fois",
      "formulasDesc": "Construisez n'importe quelle métrique demandée par votre comptable. Combinez ventes, dépenses pub, coûts et commandes en quelques clics. Sauvegardez une fois, réutilisez partout.",
      "forecastTitle": "30 jours à l'avance, pendant qu'il est encore temps",
      "forecastDesc": "Projections de revenus par source avec intervalles de confiance. Repérez la tension de trésorerie pendant qu'il est encore temps d'y faire quelque chose.",
      "aiTitle": "Une IA qui lit vos chiffres",
      "aiDesc": "Posez n'importe quelle question en français ou en anglais. Elle lit votre tableau, repère le pic, construit le graphique, explique le pourquoi — dans votre langue, pas en jargon.",
      "aiQuestion": "Pourquoi mon ROAS Meta a baissé cette semaine ?",
      "aiAnswer": "Les dépenses ont grimpé de 28 % sur deux ensembles peu performants. On les met en pause ?",
      "sharingTitle": "Partagez avec votre vraie équipe",
      "sharingDesc": "Cofondateur, comptable, assistant — invitez-les en un clic. Lecture seule ou édition. Multi-devises si votre comptable vit ailleurs.",
      "visuals": {
        "journalLabel1": "COGS",
        "journalLabel2": "TVA",
        "journalLabel3": "Frais SaaS",
        "journalValue1": "−1 840 $",
        "journalValue2": "−412 $",
        "journalValue3": "−119 $",
        "formulaSales": "Ventes",
        "formulaCosts": "Coûts",
        "formulaOrders": "Commandes",
        "formulaMargin": "Marge / commande"
      }
    },
    "persona": {
      "eyebrow": "Conçu pour votre étape",
      "title": "Même produit. Trois étapes. Choisissez la vôtre.",
      "subtitle": "Que vous cherchiez votre prochain gagnant ou que vous gériez une marque à 8 chiffres, vous voyez les métriques qui comptent à votre étape — et pas les autres.",
      "test": {
        "tab": "Test de gagnants",
        "title": "Coupez au jour 3. Scalez au jour 5.",
        "desc": "Vraie marge par SKU. Vrai CPA par ensemble de pubs. La ligne de seuil qui dit quand doubler — ou quand sortir proprement.",
        "p1": "Marge nette par SKU — après retours, frais et livraison",
        "p2": "ROAS de seuil de rentabilité, par jour, par produit",
        "p3": "Signaux couper-ou-scaler au niveau de l'ensemble de pubs",
        "kpi1Label": "Net par commande",
        "kpi1Value": "3,84 $",
        "kpi2Label": "ROAS seuil",
        "kpi2Value": "1,42×",
        "kpi3Label": "Pire SKU",
        "kpi3Value": "−0,62 $",
        "chartLabel": "Marge par test (14 derniers jours)",
        "chartValue": "+612,40 $",
        "chartTag": "3 gagnants"
      },
      "scale": {
        "tab": "Scaling de gagnants",
        "title": "Scalez sur vos chiffres, pas ceux de Meta.",
        "desc": "ROAS mélangé sur tous les canaux payants. Vrai CAC après les frais de plateforme. Une prévision de trésorerie à 30 jours pour ne plus scaler dans des mois en rouge.",
        "descNoForecast": "ROAS mélangé sur tous les canaux payants. Vrai CAC après les frais de plateforme. Un suivi de trésorerie en temps réel pour ne plus scaler dans des mois en rouge.",
        "p1": "ROAS mélangé entre Meta, TikTok et Google",
        "p2": "Vrai CAC — frais de plateforme et retours inclus",
        "p3": "Prévision de trésorerie à 30 jours, par canal",
        "p3NoForecast": "Suivi de trésorerie en temps réel, par canal",
        "kpi1Label": "ROAS mélangé",
        "kpi1Value": "3,18×",
        "kpi2Label": "CAC réel",
        "kpi2Value": "24,10 $",
        "kpi3Label": "Prévision 30 j",
        "kpi3LabelNoForecast": "Trésorerie nette",
        "kpi3Value": "8 420 $",
        "chartLabel": "Profit net (30 derniers jours)",
        "chartValue": "48 120 $",
        "chartTag": "+22 % vs préc"
      },
      "brand": {
        "tab": "Gestion de marque",
        "title": "Un vrai P&L. Pas un tracker.",
        "desc": "Des métriques personnalisées qui suivent vraiment la logique de votre comptable. Multi-devises pour les équipes internationales. Liens en lecture seule pour les partenaires financiers. Ce qui se rapproche le plus d'un CFO qui ne facture pas à l'heure.",
        "p1": "Métriques personnalisées — marge sur contribution, % COGS, autres",
        "p2": "Multi-devises avec des taux que vous contrôlez",
        "p3": "Partage par rôle pour comptables et équipe",
        "kpi1Label": "Marge brute",
        "kpi1Value": "31,4 %",
        "kpi2Label": "Profit net mensuel",
        "kpi2Value": "182 k$",
        "kpi3Label": "Mois de runway",
        "kpi3Value": "12",
        "chartLabel": "Marge sur contribution (90 j)",
        "chartValue": "214 580 $",
        "chartTag": "Sur plan"
      }
    },
    "integrations": {
      "eyebrow": "Intégrations",
      "title": "Les plateformes que vous payez déjà.",
      "desc": "Connexions officielles et sécurisées à vos boutiques et comptes publicitaires. Rien ne tourne sur votre boutique, vos clients ne voient jamais Dashbal, votre score Lighthouse ne change pas.",
      "note": "Il en manque une ? Dites-le-nous — la plupart ont été ajoutées parce qu'un client l'a demandé.",
      "soon": "Bientôt"
    },
    "pricing": {
      "eyebrow": "Tarifs",
      "title": "Quel que soit votre stade, un forfait vous correspond.",
      "subtitle": "Vous testez une boutique ? Commencez gratuitement. Vous passez à l'échelle sur plusieurs canaux ? Passez à Starter. Vous gérez une marque multicanal ? Pro. Le forfait grandit avec vous.",
      "footnote": "Changez de forfait ou résiliez à tout moment, directement dans l'app. Aucune rétention forcée — vos données restent les vôtres.",
      "publicCta": "Démarrer"
    },
    "faq": {
      "eyebrow": "Questions",
      "title": "Les questions que chaque fondateur pose avant de s'inscrire.",
      "subtitle": "Vous hésitez sur le forfait ? Commencez gratuitement, voyez vos vrais chiffres, et montez en gamme quand l'activité l'exige.",
      "q1": "Faut-il être sur Shopify ?",
      "a1": "Non. Shopify et WooCommerce fonctionnent tous les deux nativement. Si vous faites des pubs sur Meta, TikTok ou Google, branchez-les aussi — c'est là que se cache la plus grosse partie de l'argent manquant.",
      "q2": "Est-ce que Dashbal va ralentir ma boutique ?",
      "a2": "Pas du tout. Nous synchronisons via la connexion officielle fournie par chaque plateforme. Rien ne tourne sur votre boutique, vos clients ne chargent rien de plus, votre score Lighthouse ne s'en aperçoit pas.",
      "q3": "Où sont mes données et sont-elles en sécurité ?",
      "a3": "Chiffrées en transit et au repos, hébergées sur des infrastructures EU et US renforcées. Nous ne les vendons pas, nous ne les partageons pas. Exportez ou supprimez tout le compte depuis vos paramètres — sans ticket d'assistance.",
      "q4": "Puis-je annuler ?",
      "a4": "Depuis l'application. Pas d'appel, pas d'enquête de sortie, pas de « êtes-vous sûr ? » trois fois. Le plan gratuit reste gratuit. Vos données restent accessibles.",
      "q5": "En quoi c'est différent de Triple Whale ou Lifetimely ?",
      "a5": "Triple Whale mise sur l'attribution ; Lifetimely sur la valeur client. Dashbal se concentre entièrement sur votre vrai profit net après chaque coût — avec Shopify et WooCommerce en natif, une gestion correcte de la TVA, des journaux de dépenses par IA (photo du reçu), une prévision de trésorerie à 30 jours et une IA qui construit vos graphiques. En français et en anglais, avec un plan réellement gratuit — pas juste un essai.",
      "a5NoForecast": "Triple Whale mise sur l'attribution ; Lifetimely sur la valeur client. Dashbal se concentre entièrement sur votre vrai profit net après chaque coût — avec Shopify et WooCommerce en natif, une gestion correcte de la TVA, des journaux de dépenses par IA (photo du reçu), un suivi de trésorerie en temps réel et une IA qui construit vos graphiques. En français et en anglais, avec un plan réellement gratuit — pas juste un essai.",
      "q6": "Puis-je importer mes données historiques ?",
      "a6": "Oui. À la connexion, nous récupérons ce que chaque plateforme autorise — généralement 60 à 180 jours. Les journaux financiers acceptent les entrées passées et les règles récurrentes dès le premier jour.",
      "q7": "Avec qui puis-je partager ?",
      "a7": "Cofondateurs, comptables, assistants, partenaires financiers. Lecture seule ou édition, tableau par tableau. Les utilisateurs invités n'ont pas besoin d'un plan payant pour voir ce que vous leur avez partagé."
    },
    "finalCta": {
      "title": "Voyez le chiffre qui arrive vraiment sur votre compte.",
      "subtitle": "Connectez une boutique et un compte publicitaire — Dashbal affiche votre vrai profit net, après chaque coût, en environ deux minutes. Gratuit, sans carte."
    },
    "hero": {
      "totalRevenue": "Revenu Total",
      "netProfit": "Bénéfice Net",
      "adSpend": "Dépenses Publicitaires",
      "vsLastWeek": "vs période préc.",
      "revenueGrowth": "Croissance des Revenus",
      "thisMonth": "Ce mois-ci",
      "aiInsight": "ALERTE MARGE",
      "insightTextPart1": "Vos dépenses pub sur",
      "insightTextPart2": "et",
      "insightTextPart3": "ont grimpé cette semaine — les marges n'ont pas suivi. Deux ensembles de pubs tirent la moyenne vers le bas.",
      "applyRecommendation": "Voir",
      "activeChannels": "Canaux connectés",
      "connected": "Connecté",
      "roasAlert": "ROAS EN BAISSE",
      "checkMetaAds": "Couper 2 ensembles"
    }
  },
  "demo": {
    "heroBadge": "30 minutes. Sans diapos.",
    "heroTitle": "Apportez vos chiffres. On vous montre ce qu'ils disent vraiment.",
    "heroSubtitle": "Nous ouvrons Dashbal avec vos canaux en tête, répondons aux questions gênantes, et vous disons franchement si ça va faire bouger les choses pour votre boutique. Ou si ça ne le fera pas — pour l'instant.",
    "form": {
      "title": "Parlez-nous un peu de votre boutique",
      "subtitle": "Ces infos servent à rendre l'appel utile. Rien n'est partagé, rien ne va sur une liste.",
      "name": "Votre nom",
      "namePlaceholder": "Jane Doe",
      "email": "E-mail professionnel",
      "emailPlaceholder": "vous@boutique.com",
      "company": "Nom de la boutique ou marque",
      "companyPlaceholder": "Acme Apparel",
      "role": "Votre rôle",
      "rolePlaceholder": "Fondateur, CMO, responsable financier…",
      "teamSize": "Taille de l'équipe",
      "teamSizePlaceholder": "Vous êtes combien ?",
      "monthlyRevenue": "Revenu mensuel",
      "monthlyRevenuePlaceholder": "Choisir une fourchette",
      "revenue": {
        "under_10k": "Moins de 10k $",
        "10k_50k": "10k – 50k $",
        "50k_250k": "50k – 250k $",
        "250k_1m": "250k $ – 1M $",
        "over_1m": "Plus de 1M $"
      },
      "channels": "Où vendez-vous ou faites-vous de la publicité ?",
      "slot": "Choisissez un créneau",
      "slotNote": "Les horaires sont affichés dans votre fuseau. Confirmation par e-mail.",
      "message": "Y a-t-il un point précis que vous voulez voir ?",
      "messagePlaceholder": "Un produit dont vous ne fiez plus la marge ? Un tableau que vous rêveriez d'avoir ? Une facture qui ne collait pas avec ce que Meta disait ?",
      "submit": "Demander une démo",
      "submitting": "Envoi…",
      "errorGeneric": "Quelque chose a mal tourné de notre côté. Réessayez dans un instant.",
      "privacy": "Nous ne partageons pas vos coordonnées et nous ne vous mettrons pas sur une liste marketing."
    },
    "benefits": {
      "title": "Ce que vous obtenez de l'appel",
      "b1": "Trente minutes ciblées sur les fonctionnalités utiles à votre étape.",
      "b2": "Des réponses en direct de quelqu'un qui a construit le produit, pas d'un commercial qui suit un script.",
      "b3": "Un deuxième avis honnête sur les chiffres que vous voyez déjà.",
      "b4": "Une étape suivante claire — y compris « pas tout de suite » si c'est la bonne réponse."
    },
    "languages": {
      "title": "FR ou EN — c'est vous qui choisissez",
      "body": "Choisissez la langue dans laquelle vous feriez une revue de P&L. Même équipe, même produit, même niveau de détail."
    },
    "startNow": {
      "title": "Envie d'explorer d'abord ?",
      "body": "Commencez gratuitement, connectez un canal et voyez vos vrais chiffres en quelques minutes. Passez à Starter ou Pro à mesure que vous ajoutez des canaux et de l'historique — ou réservez un appel si vous voulez un coup de main."
    },
    "success": {
      "title": "C'est bien reçu.",
      "body": "Nous revenons vers vous dans un jour ouvré avec un créneau confirmé. Si vous ne voyez rien, vérifiez vos spams — et s'il manque toujours quelque chose, répondez à n'importe lequel de nos e-mails.",
      "bookAnother": "Envoyer une autre demande"
    }
  },
  "oauth": {
    "errorTitle": "Problème de Connexion",
    "successTitle": "Succès OAuth",
    "authorizationFailed": "Autorisation échouée",
    "authorizationSuccessful": "Autorisation réussie",
    "windowWillClose": "Cette fenêtre se fermera automatiquement...",
    "missingParameters": "Paramètres OAuth requis manquants",
    "invalidState": "Jeton d'état invalide ou expiré",
    "duplicateConnection": "Vous avez déjà une connexion pour ce canal. Veuillez d'abord déconnecter l'existante.",
    "pluginNotFound": "Plugin de canal non trouvé",
    "serverError": "Nous avons eu du mal à nous connecter au service",
    "safeToClose": "Vous pouvez fermer cette fenêtre en toute sécurité",
    "secureGateway": "Passerelle Sécurisée Dashbal"
  },
  "datePicker": {
    "selectDateRange": "Sélectionner une plage de dates",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "quickRanges": "Plages rapides",
    "yesterday": "Hier",
    "last7Days": "7 derniers jours",
    "last30Days": "30 derniers jours",
    "last60Days": "60 derniers jours",
    "last365Days": "365 derniers jours",
    "apply": "Appliquer",
    "cancel": "Annuler"
  },
  "currency": {
    "boardCurrency": "Devise de l'espace de travail",
    "defaultCurrency": "Devise par défaut",
    "convertedCurrencies": "Devises converties",
    "currencyConversion": "Conversion de devise",
    "conversionRate": "Taux de conversion",
    "to": "vers",
    "changeCurrency": "Changer la devise",
    "mixedCurrenciesWarning": "Plusieurs devises détectées dans l'espace de travail",
    "disclaimer": "Les taux de conversion de devises sont définis par l'utilisateur et à titre indicatif uniquement. Dashbal n'est pas responsable de l'exactitude de ces conversions. Veuillez vérifier les taux auprès de votre institution financière.",
    "noCurrency": "Aucune devise définie",
    "currencyUpdated": "Devise mise à jour avec succès",
    "selectCurrency": "Sélectionner une devise",
    "automaticRate": "Taux automatique basé sur les données du marché",
    "resetToAutomatic": "Réinitialiser au taux automatique",
    "rateReset": "Taux réinitialisé au taux automatique",
    "rateResetFailed": "Échec de la réinitialisation du taux",
    "ratesUpdated": "Taux de change mis à jour",
    "newCurrenciesDetected": "Nouvelles devises détectées : {{currencies}}",
    "updateSuccess": "Paramètres de devise mis à jour avec succès",
    "updateFailed": "Échec de la mise à jour des paramètres de devise",
    "previewFailed": "Échec du chargement de l'aperçu de la devise",
    "usd": "USD - US Dollar",
    "eur": "EUR - Euro",
    "gbp": "GBP - British Pound",
    "jpy": "JPY - Japanese Yen",
    "cad": "CAD - Canadian Dollar",
    "aud": "AUD - Australian Dollar",
    "chf": "CHF - Swiss Franc",
    "cny": "CNY - Chinese Yuan",
    "inr": "INR - Indian Rupee",
    "brl": "BRL - Brazilian Real",
    "tnd": "TND - Dinar tunisien"
  },
  "itemSelection": {
    "title": "Sélection de données",
    "subtitle": "Sélectionner des éléments de {{channelName}}",
    "manageSelections": "Gérez vos sélections de données sur tous les canaux",
    "selectItems": "Sélectionner des éléments",
    "selectItemsDescription": "Choisissez les sources de données que vous souhaitez suivre sur cet espace de travail",
    "selectEntitiesDescription": "Gérez vos sources de données et vos journaux pour cet espace de travail",
    "preview": "Aperçu de la sélection",
    "previewDescription": "Vérifiez vos éléments sélectionnés avant de valider",
    "noSelection": "Aucun élément sélectionné",
    "noSelectionHint": "Sélectionnez des éléments dans la liste à gauche pour les prévisualiser ici",
    "selectedCount": "{{count}} éléments sélectionnés",
    "readyToValidate": "{{count}} éléments prêts à être ajoutés",
    "noSelectionWarning": "Aucun élément sélectionné - la validation supprimera ce canal",
    "validate": "Confirmer",
    "noSelectionTitle": "Aucun élément sélectionné",
    "noSelectionMessage": "Vous n'avez sélectionné aucun élément. Si vous validez maintenant, ce canal sera supprimé de l'espace de travail. Voulez-vous continuer ?",
    "removeChannel": "Supprimer le canal",
    "openModal": "Ouvrir la sélection de données",
    "clickToOpen": "Cliquez sur le bouton + pour gérer vos sélections de données",
    "selectItemsInstructions": "Sélectionnez les éléments que vous souhaitez suivre",
    "selectEntitiesInstructions": "Sélectionnez les éléments que vous souhaitez inclure",
    "selectAccount": "Sélectionnez un compte à afficher"
  },
  "transactionCategories": {
    "product_sale": "Ventes de produits",
    "product_return": "Retours de produits",
    "partial_return": "Retours partiels",
    "discount": "Remises",
    "shipping": "Livraison",
    "shipping_refund": "Remboursements de livraison",
    "tax": "Taxes",
    "tax_refund": "Remboursements de taxes",
    "refund_adjustment": "Ajustements de remboursement",
    "transaction_fee": "Frais de traitement",
    "net_return": "Retours",
    "other": "Autre",
    "revenue": "Revenu",
    "expense": "Dépense"
  },
  "common": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "creating": "Création...",
    "saving": "Enregistrement...",
    "productsCount": "{{count}} Produits",
    "delete": "Supprimer",
    "duplicate": "Dupliquer",
    "copy": "Copie",
    "selected": "sélectionné",
    "operations": "opérations",
    "noItemsFound": "Aucun élément trouvé",
    "success": "Succès",
    "revenue": "Revenu",
    "expense": "Dépense",
    "edit": "Modifier",
    "items": "éléments",
    "selectAll": "Tout sélectionner",
    "remove": "Supprimer",
    "unnamed": "Sans titre",
    "created": "Créé",
    "date": "Date",
    "updating": "Mise à jour...",
    "noResults": "Aucun résultat trouvé",
    "alreadySelected": "Déjà sélectionné",
    "search": "Rechercher",
    "viewFiles": "Documents",
    "addFiles": "Documents",
    "added": "Added",
    "actual": "Actual",
    "download": "Download",
    "lower": "Lower",
    "upper": "Upper",
    "channels": {
      "syncing": "Syncing..."
    }
  },
  "itemTypes": {
    "adAccount": "Compte Publicitaire",
    "campaign": "Campagne",
    "adSet": "Ensemble de Publicités",
    "ad": "Publicité"
  },
  "modals": {
    "addJournal": {
      "title": "Ajouter un journal",
      "journalName": "Nom du journal",
      "namePlaceholder": "ex: Budget T1, Revenus Freelance",
      "importDataOptional": "Importer des données (Optionnel)",
      "dropZone": {
        "title": "Déposez un fichier ici",
        "subtitle": "ou cliquez pour parcourir",
        "formats": "Fichiers CSV et Excel acceptés"
      },
      "createAction": "Créer le journal",
      "error": "Échec de la création du journal. Veuillez réessayer."
    },
    "addFinancialOperation": {
      "title": "Ajouter un enregistrement financier",
      "amount": "Montant",
      "currency": "Devise",
      "operationStructure": "Structure de l'enregistrement",
      "oneTime": "Paiement unique",
      "periodic": "Paiement périodique",
      "date": "Date de paiement",
      "startDate": "Date de début",
      "frequency": "Fréquence",
      "frequencies": {
        "daily": "Quotidien",
        "weekly": "Hebdomadaire",
        "monthly": "Mensuel",
        "yearly": "Annuel"
      },
      "endDateOptional": "Définir une date de fin",
      "endDate": "Date de fin",
      "createAction": "Ajouter",
      "error": "Échec de la création de l'enregistrement"
    },
    "shareJournal": {
      "title": "Partager \"{{name}}\"",
      "subtitle": "Partagez ce journal avec d'autres utilisateurs",
      "emailLabel": "Adresse e-mail",
      "permissionLabel": "Permission",
      "inviteButton": "Inviter",
      "usersWithAccess": "Utilisateurs avec accès",
      "owner": "Propriétaire",
      "remove": "Retirer"
    },
    "exportOperations": {
      "title": "Export Operations",
      "subtitle": "Choose the best format for your needs",
      "formats": {
        "csvExcel": "CSV for Excel",
        "csvExcelDesc": "Optimized for Excel, Numbers, and other spreadsheet tools",
        "csvPlain": "Plain CSV",
        "csvPlainDesc": "Standard comma-separated values file"
      }
    },
    "operationFileExplorer": {
      "title": "Fichiers de l'opération",
      "empty": "Aucun fichier joint",
      "emptyDesc": "Faites glisser et déposez des fichiers ici ou utilisez le bouton ci-dessus pour joindre des documents à cette opération.",
      "tip": "Astuce : Glissez-déposez des fichiers n'importe où pour les télécharger instantanément",
      "searchPlaceholder": "Rechercher des fichiers...",
      "addFile": "Ajouter un fichier",
      "uploading": "Téléchargement...",
      "alerts": {
        "loadError": "Échec du chargement des fichiers",
        "uploadSuccess": "Fichier ajouté avec succès",
        "uploadError": "Échec de l'envoi du fichier",
        "deleteSuccess": "Fichier supprimé",
        "deleteError": "Échec de la suppression du fichier",
        "downloadError": "Échec du téléchargement"
      }
    }
  },
  "boardJournals": {
    "inBoardModal": {
      "openInFullView": "Ouvrir en pleine page",
      "creating": "Création du journal..."
    },
    "list": {
      "headers": {
        "status": "Statut",
        "name": "Nom du journal",
        "actions": "Actions"
      },
      "emptyState": "Aucun journal trouvé. Ajoutez-en un pour commencer.",
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer ce journal ?",
      "deleteJournal": "Supprimer le journal",
      "journalDeleted": "Journal supprimé avec succès",
      "deleteJournals": "Supprimer les journaux",
      "confirmDeleteBulk": "Êtes-vous sûr de vouloir supprimer ces journaux ?"
    },
    "types": {
      "automated": "Automatisé"
    },
    "details": {
      "headers": {
        "name": "Nom de l'enregistrement",
        "value": "Valeur",
        "operation": "Nom de l'opération",
        "amount": "Montant",
        "date": "Date"
      },
      "defaultOperationName": "Opération {{number}}",
      "amountPlaceholder": "0.00",
      "emptyState": "Aucun enregistrement trouvé.",
      "orDragAndDrop": "glisser-déposer",
      "chooseFile": "Choisir un fichier",
      "aiAnalysisPromo": "pour une analyse IA instantanée",
      "dragActive": "Déposer pour analyser",
      "dragActiveSubtitle": "L'IA traitera votre fichier instantanément",
      "aiProcessing": {
        "analyzing": "Analyse de la structure du document",
        "extracting": "Extraction des données financières",
        "classifying": "Classification des données",
        "finalizing": "Finalisation des écritures"
      },
      "cancelProcessing": "Annuler l'analyse",
      "loading": "Chargement des opérations...",
      "emptyStateText": "Ajoutez une opération à ce journal pour commencer.",
      "untitledOperation": "Opération sans titre",
      "recurring": "Récurrent",
      "openEnded": "Sans fin",
      "deleteConfirm": "Êtes-vous sûr de vouloir supprimer cette opération ?",
      "frequencies": {
        "daily": "Quotidien",
        "weekly": "Hebdomadaire",
        "monthly": "Mensuel",
        "yearly": "Annuel"
      },
      "deleteOperation": "Supprimer l'opération",
      "operationDeleted": "Opération supprimée avec succès",
      "operationCreated": "Opération créée avec succès",
      "chooseFileOrDragAndDrop": "Choisir un fichier ou glisser-déposer",
      "aiFileAnalysis": "Importation de document par l'IA",
      "deleteOperations": "Supprimer les opérations",
      "confirmDeleteBulk": "Êtes-vous sûr de vouloir supprimer ces opérations ?"
    },
    "addJournal": "Ajouter un journal",
    "createJournal": "Créer un journal",
    "manageJournals": "Gérer les journaux",
    "emptyTitle": "Aucun journal",
    "emptyDescription": "Les journaux contiennent des opérations financières ponctuelles ou récurrentes. Ajoutez-les à l'analyse de votre espace de travail.",
    "tabs": {
      "myJournals": "Mes Journaux",
      "sharedWithMe": "Partagés avec moi"
    },
    "journal": "Journal"
  },
  "journals": {
    "myJournals": "Mes Journaux",
    "sharedWithMe": "Partagés avec moi",
    "journal": "Journal",
    "emptyTitle": "Aucun journal pour l'instant",
    "emptyDescription": "Les journaux sont des listes globales d'opérations financières. Vous pouvez les lier à n'importe quel espace de travail.",
    "noSharedJournals": "Aucun journal partagé",
    "noSharedJournalsDescription": "Les journaux partagés avec vous apparaîtront ici.",
    "deleteJournal": "Supprimer le journal",
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer définitivement ce journal ? Cela le retirera de tous vos espaces de travail et supprimera toutes ses opérations.",
    "deleteJournals": "Delete Journals",
    "confirmDeleteBulk": "Are you sure you want to delete these journals?"
  },
  "plans": {
    "unlockTitle": "Débloquez votre forfait",
    "paymentIssue": "Il y a un problème avec votre mode de paiement. Veuillez le mettre à jour dans votre profil pour maintenir votre abonnement actif.",
    "loading": "Chargement des forfaits...",
    "noPlansAvailable": "Aucun forfait disponible dans votre région.",
    "billingViaShopify": "La facturation de Dashbal est gérée via le Shopify App Store.",
    "getOnShopify": "Obtenir Dashbal sur Shopify",
    "monthly": "Mensuel",
    "yearly": "Annuel",
    "perMonth": "mois",
    "perYear": "an",
    "billedAnnually": "facturé annuellement",
    "billedMonthly": "facturé mensuellement",
    "freePrice": "Gratuit",
    "currentPlan": "Forfait actuel",
    "getStarted": "Commencer",
    "upgradeTo": "Passer à {{planName}}",
    "pricesFor": "Prix pour",
    "defaultDescription": "Tout ce dont vous avez besoin pour commencer.",
    "downgradeToFree": "Switch to Free",
    "confirmDowngrade": "Switch to Free Plan?",
    "getPlan": "Get {{planName}}",
    "downgradeMessage": "Your current subscription will be canceled at the end of the billing period, and you will revert to the free plan.",
    "changePlan": "Change Your Plan",
    "loadPreviewFailed": "Unable to load plan change details",
    "changePlanFailed": "Failed to change plan",
    "current": "Current",
    "new": "New",
    "credit": "Credit",
    "paymentSummary": "Payment Summary",
    "dueNow": "Due Now",
    "nextPayment": "Next Payment {{frequency}}",
    "processing": "Processing...",
    "confirmChange": "Confirm Change",
    "downgradeSuccess": "Plan downgraded successfully (pending period end)",
    "downgradeFailed": "Failed to downgrade plan",
    "updateSuccess": "Plan updated successfully"
  },
  "documentAnalysis": {
    "title": "Import IA de Documents",
    "analyzing": "Analyse du document...",
    "extracting": "Extraction des opérations...",
    "processing": "Traitement de votre document",
    "success": "Opérations extraites avec succès",
    "noOperationsFound": "Aucune opération trouvée dans le document",
    "operationsFound": "{{count}} opérations trouvées",
    "operationsSaved": "{{count}} opérations enregistrées dans le journal",
    "partialSave": "{{saved}} sur {{total}} opérations enregistrées",
    "reviewOperations": "Vérifier les opérations extraites",
    "confirmImport": "Importer les opérations",
    "cancelImport": "Annuler",
    "retryAnalysis": "Réessayer",
    "supportedFormats": "Formats supportés : Images, PDFs, CSV, Excel",
    "maxFileSize": "Taille maximale : {{size}}Mo",
    "dropToAnalyze": "Déposez le fichier pour analyser",
    "clickOrDrop": "Cliquez ou déposez un fichier à analyser",
    "results": {
      "title": "Résultats de l'analyse",
      "totalOperations": "Total des opérations",
      "totalRevenue": "Revenus totaux",
      "totalExpense": "Dépenses totales",
      "currencies": "Devises détectées",
      "confidence": "Confiance",
      "warnings": "Avertissements"
    },
    "errors": {
      "generic": "Échec de l'analyse du document. Veuillez réessayer.",
      "noFileProvided": "Veuillez sélectionner un fichier à analyser.",
      "fileTooLarge": "Le fichier est trop volumineux. Veuillez choisir un fichier plus petit.",
      "unsupportedFileType": "Ce type de fichier n'est pas pris en charge. Veuillez utiliser une image, un PDF, un CSV ou un fichier Excel.",
      "fileCorrupted": "Le fichier semble être corrompu ou endommagé.",
      "fileEmpty": "Le fichier est vide. Veuillez choisir un fichier avec du contenu.",
      "fileReadError": "Impossible de lire le fichier. Veuillez réessayer.",
      "providerNotConfigured": "L'analyse de documents est actuellement indisponible. Veuillez contacter le support.",
      "providerNotFound": "Service d'analyse de documents introuvable.",
      "providerConnectionFailed": "Nous avons du mal à joindre notre service d'analyse. Veuillez réessayer.",
      "providerAuthFailed": "Nous avons du mal à nous connecter à notre service d'analyse. Veuillez contacter le support.",
      "providerTimeout": "L'analyse a expiré. Veuillez essayer un fichier plus petit ou réessayer.",
      "providerUnavailable": "Le service d'analyse est temporairement hors ligne. Veuillez réessayer dans quelques instants.",
      "analysisFailed": "Échec de l'analyse du document. Veuillez réessayer.",
      "noOperationsFound": "Aucune opération financière n'a pu être trouvée dans ce document.",
      "invalidDataFormat": "Nous n'avons pas pu lire ce document. Veuillez vérifier le format du fichier.",
      "partialExtraction": "Certaines données n'ont pas pu être extraites du document.",
      "ambiguousCurrency": "Plusieurs devises détectées. Veuillez vérifier les résultats.",
      "dateParsingFailed": "Certaines dates n'ont pas pu être analysées correctement.",
      "amountParsingFailed": "Certains montants n'ont pas pu être lus correctement.",
      "rateLimitExceeded": "Trop de requêtes. Veuillez patienter un moment et réessayer.",
      "quotaExceeded": "Quota d'analyse dépassé. Veuillez réessayer plus tard.",
      "concurrentLimit": "Trop de fichiers en cours de traitement. Veuillez patienter et réessayer."
    }
  },
  "boardMainSpace": {
    "title": "Board Layout",
    "description": "This is the main container for your board content.",
    "features": "It handles scrolling, animations, and layout structure."
  },
  "profile": {
    "appearance": "Apparence",
    "themeLight": "Clair",
    "themeDark": "Sombre",
    "themeSystem": "Auto",
    "general": "Général",
    "channels": "Canaux",
    "notifications": "Notifications",
    "plan": "Plan",
    "billing": {
      "label": "Facturation",
      "confirmRemovePaymentMethod": "Êtes-vous sûr de vouloir supprimer ce mode de paiement ?",
      "cancelSubscriptionMessage": "Votre abonnement restera actif jusqu'à la fin de votre période de facturation actuelle. Vous pourrez le reprendre à tout moment d'ici là.",
      "confirmCancelAction": "Oui, annuler le forfait",
      "keepPlanAction": "Garder le forfait",
      "cancellationNotice": "Votre abonnement se terminera le {{date}}. Vous pouvez continuer à utiliser toutes les fonctionnalités d'ici là.",
      "endsOn": "Se termine le {{date}}",
      "renewsOn": "Renouvellement le {{date}}",
      "paymentIssue": "Problème de paiement",
      "paymentIssueDesc": "Votre dernier paiement a échoué. Veuillez mettre à jour votre mode de paiement.",
      "updatePaymentMethod": "Mettre à jour le mode de paiement",
      "switchingTo": "Passage à {{plan}} le",
      "cancelSchedule": "Annuler le changement"
    },
    "activity": "Historique d'activité",
    "privacy": {
      "label": "Confidentialité",
      "deleteAccountTitle": "Zone de danger",
      "deleteAccountDesc": "Permanently delete your account and all associated data, including Facebook platform data. This action cannot be undone.",
      "deleteAccountBtn": "Delete Account & Data",
      "shopifyDeleteLockedTitle": "Désinstallez d'abord depuis Shopify",
      "shopifyDeleteLockedDesc": "Votre abonnement est géré par Shopify. Pour supprimer votre compte, désinstallez d'abord l'application Dashbal depuis votre admin Shopify — cela annule l'abonnement et démarre la période de grâce pour la suppression des données. Une fois cela fait, vous pourrez supprimer votre compte ici.",
      "confirmDeleteAccountTitle": "Delete Account?",
      "confirmDeleteAccountMsg": "Are you sure you want to delete your account? All your data, including connected Facebook data, will be permanently removed from our servers.",
      "accountDeleted": "Your account has been deleted successfully."
    },
    "manageAccount": "Gérez vos paramètres de compte et vos préférences",
    "filter": "Filtrer",
    "allActivity": "Toute l'activité",
    "event": "activité",
    "events": "activités",
    "noActivity": "Aucune activité pour l'instant",
    "activityDescription": "Votre historique d'activité s'affichera ici",
    "loadMoreActivity": "Charger plus d'activité",
    "loadingActivity": "Chargement...",
    "categories": {
      "label": "Catégories",
      "security": "Sécurité",
      "payment": "Facturation",
      "channel": "Intégrations",
      "board": "Tableaux",
      "user": "Compte"
    },
    "profilePhoto": "Photo de Profil",
    "photoDescription": "Téléchargez une photo de profil pour personnaliser votre compte. Nous vous recommandons d'utiliser une image carrée.",
    "uploadPhoto": "Charger une photo",
    "removePhoto": "Supprimer la photo",
    "editPhoto": "Modifier la photo",
    "personalInfo": "Informations Personnelles",
    "changePassword": "Changer le Mot de Passe",
    "currentPassword": "Mot de Passe Actuel",
    "newPassword": "Nouveau Mot de Passe",
    "updatePassword": "Mettre à jour le Mot de Passe",
    "preferences": "Préférences",
    "defaultCurrency": "Devise par Défaut",
    "timezone": "Fuseau Horaire",
    "security": "Security",
    "passwordLastChanged": "Password last changed",
    "user": "User",
    "myChannels": "My Channels",
    "manageChannelSettings": "View and manage all your connected sales and marketing channels",
    "connectChannelsToStart": "Connect your first channel to start importing and tracking your financial data",
    "emailNotifications": "Email Notifications",
    "emailNotificationsLabel": "Receive Email Updates",
    "emailNotificationsDesc": "Get email notifications about important account activity and updates",
    "channelAlerts": "Channel Connection Alerts",
    "channelAlertsDesc": "Receive alerts when there are connection issues or sync problems with your channels",
    "weeklyReports": "Weekly Summary Reports",
    "weeklyReportsDesc": "Get a weekly email summary of your sales, revenue, and key metrics",
    "monthlyReports": "Monthly Summary Reports",
    "monthlyReportsDesc": "Receive a comprehensive monthly report with insights and trends",
    "systemNotifications": "System & Account Notifications",
    "securityAlerts": "Security & Login Alerts",
    "securityAlertsDesc": "Recevez des alertes pour les événements de sécurité importants comme les nouvelles connexions et les changements de mot de passe",
    "marketingEmails": "Product Updates & News",
    "marketingEmailsDesc": "Stay informed about new features, product updates, and special offers",
    "currentPlan": "Current Plan",
    "planRenews": "Renews on",
    "selectPlan": "Select Plan",
    "upgrade": "Upgrade Plan",
    "paymentMethod": "Payment Method",
    "addPaymentMethod": "Add Payment Method",
    "billingHistory": "Billing History",
    "download": "Download Invoice",
    "cancelSubscription": "Cancel Subscription",
    "cancelSubscriptionDesc": "Once you cancel, you'll lose access to all premium features at the end of your current billing period. Your data will be preserved for 30 days.",
    "addressLine1": "Address Line 1",
    "city": "City",
    "state": "State",
    "zipCode": "ZIP / Postal Code",
    "countryPlaceholder": "Country (e.g. US)",
    "paymentMethods": "Payment Methods",
    "noPaymentMethods": "No payment methods saved.",
    "loadingBillingHistory": "Loading billing history...",
    "noBillingHistory": "No billing history available",
    "unsavedChanges": "Unsaved changes",
    "cancelPlan": "Cancel Plan",
    "keepSubscription": "Keep my subscription",
    "cancellationScheduled": "Cancellation scheduled.",
    "billingAddress": "Billing Address",
    "noAddressSet": "No address set",
    "confirmPassword": "Confirmer le mot de passe",
    "freePlan": "Forfait Gratuit",
    "freeTrial": "Essai gratuit",
    "noSubscription": "Aucun abonnement actif",
    "noSubscriptions": "Aucun abonnement",
    "trialExpiresToday": "L'essai expire aujourd'hui",
    "cancelTrial": "Annuler l'essai",
    "trialDaysLeft": "{{count}} jour restant dans l'essai",
    "trialDaysLeft_plural": "{{count}} jours restants dans l'essai",
    "viewPlans": "Voir les forfaits",
    "canceling": "ANNULATION",
    "downloadInvoice": "Télécharger la facture",
    "analytics": "Analyses",
    "analyticsDesc": "Activer le suivi analytique",
    "saving": "Enregistrement...",
    "discardChanges": "Abandonner les modifications",
    "saveChanges": "Enregistrer les modifications",
    "public": "Public Profile"
  },
  "sharing": {
    "share": "Partager",
    "readOnly": "Lecture seule",
    "permissions": {
      "read": "Read Only",
      "readwrite": "Read & Write"
    },
    "invalidLink": "Invalid Share Link",
    "accepted": "Share Accepted!",
    "acceptedDesc": "The journal has been added to your shared journals.",
    "redirecting": "Redirecting...",
    "ownJournal": "This is Your Journal",
    "ownJournalDesc": "You can",
    "goToJournals": "Go to Journals",
    "alreadyAccepted": "Already Accepted",
    "alreadyAcceptedDesc": "You already have access to this journal.",
    "invitationTitle": "Journal Shared With You",
    "sharedWith": "has shared a journal with you",
    "canEdit": "You can view and add operations",
    "canView": "You can view operations",
    "readWriteAccess": "Read & Write Access",
    "readOnlyAccess": "Read Only Access",
    "removeAccess": "Remove Access",
    "removeShareTitle": "Remove Access?",
    "removeShareMessage": "Are you sure you want to remove access for {{email}}? This action cannot be undone.",
    "updateSuccess": "Journal shares updated successfully",
    "updateError": "Failed to update journal shares",
    "readWrite": "Read & Write",
    "addAnother": "Add another person"
  },
  "timezones": {
    "utc": "UTC",
    "usEastern": "US/Eastern",
    "usCentral": "US/Central",
    "usMountain": "US/Mountain",
    "usPacific": "US/Pacific",
    "europeLondon": "Europe/London",
    "europeParis": "Europe/Paris",
    "europeBerlin": "Europe/Berlin",
    "asiaDubai": "Asia/Dubai",
    "asiaKolkata": "Asia/Kolkata",
    "asiaSingapore": "Asia/Singapore",
    "asiaTokyo": "Asia/Tokyo",
    "australiaSydney": "Australia/Sydney"
  },
  "maintenance": {
    "title": "Accès Développeur Requis",
    "description": "Cet environnement est réservé aux développeurs. Veuillez saisir votre code d'accès pour continuer.",
    "accessCode": "Code d'Accès",
    "enterCode": "Saisir le code d'accès",
    "verifying": "Vérification...",
    "accessApp": "Accéder à l'Application",
    "contactAdmin": "Si vous n'avez pas de code d'accès, veuillez contacter votre administrateur.",
    "footer": "© {{year}} Dashbal. Environnement Développeur.",
    "pleaseEnterCode": "Veuillez saisir un code d'accès",
    "invalidCode": "Code d'accès invalide",
    "loading": "Chargement..."
  },
  "help": {
    "center": "Help Center",
    "howCanWeHelp": "How can we help you?",
    "sendMessageDesc": "Send us a message and we'll get back to you shortly.",
    "name": "Name",
    "namePlaceholder": "Your name",
    "email": "Email",
    "emailPlaceholder": "you@example.com",
    "subject": "Subject",
    "generalInquiry": "General Inquiry",
    "technicalSupport": "Technical Support",
    "billingQuestion": "Billing Question",
    "featureRequest": "Feature Request",
    "other": "Other",
    "message": "Message",
    "messagePlaceholder": "Describe your issue or question...",
    "sendMessage": "Send Message",
    "orEmailUs": "Or email us directly at"
  },
  "checkout": {
    "processing": "Processing Payment...",
    "waitConfirm": "Please wait while we confirm your subscription.",
    "takingLonger": "Taking longer than expected",
    "couldNotConfirm": "We couldn't confirm your subscription yet. It might take a few moments.",
    "errorTitle": "Un problème est survenu",
    "sessionMismatch": "Cette session de paiement appartient à un autre compte. Veuillez vous assurer d'être connecté avec le bon compte et réessayer.",
    "sessionExpired": "Cette session de paiement a expiré ou est invalide. Veuillez relancer un paiement depuis la page des forfaits.",
    "returnToProfile": "Return to Profile",
    "successMessage": "Subscription successfully activated!"
  },
  "legal": {
    "lastUpdated": "Dernière mise à jour",
    "tos": {
      "title": "Conditions Générales d'Utilisation",
      "sections": {
        "intro": {
          "title": "1. Acceptation des conditions",
          "content": "Les présentes Conditions Générales d'Utilisation (« CGU » ou « Conditions ») constituent un accord juridiquement contraignant entre vous (« Utilisateur », « vous » ou « votre ») et Dashbal (« Dashbal », « nous », « notre » ou « nos »), régissant votre accès et votre utilisation de la plateforme Dashbal, du site web, des applications et des services associés (collectivement, le « Service »).\n\nEn créant un compte, en cliquant sur « J'accepte » ou en accédant au Service, vous confirmez avoir lu, compris et accepté d'être lié par les présentes Conditions et notre Politique de Confidentialité (intégrée par référence). Si vous n'acceptez pas ces Conditions, vous ne pouvez pas utiliser le Service.\n\nCes Conditions s'appliquent à tous les utilisateurs, y compris les particuliers, les entreprises et toute partie accédant au Service au nom d'une entité. Si vous utilisez le Service au nom d'une organisation, vous déclarez avoir l'autorité d'engager cette organisation par ces Conditions."
        },
        "eligibility": {
          "title": "2. Conditions d'éligibilité",
          "content": "Pour utiliser le Service, vous devez :\n• Être âgé d'au moins 18 ans\n• Avoir la capacité juridique de conclure des contrats contraignants conformément à la loi applicable\n• Ne pas être interdit d'utiliser le Service par les lois de votre juridiction\n• Utiliser le Service uniquement à des fins commerciales légales\n\nEn créant un compte, vous déclarez et garantissez que toutes les informations d'inscription que vous fournissez sont exactes, à jour et complètes, et que vous maintiendrez leur exactitude tout au long de votre utilisation du Service."
        },
        "accounts": {
          "title": "3. Comptes utilisateurs",
          "content": "Responsabilité du compte : Vous êtes seul responsable de la confidentialité de vos identifiants de connexion et de toutes les activités effectuées sous votre compte. Notifiez-nous immédiatement à support@dashbal.com de tout accès non autorisé ou de toute suspicion de violation de sécurité.\n\nIntégrité du compte : Vous ne pouvez pas créer plus d'un compte par personne ou entité sans notre consentement écrit préalable. Vous ne pouvez pas usurper l'identité d'une autre personne ni créer de comptes avec de fausses identités.\n\nInactivité : Nous nous réservons le droit de suspendre les comptes inactifs pendant plus de 12 mois consécutifs après vous avoir notifié 30 jours à l'avance."
        },
        "billing": {
          "title": "4. Abonnements, facturation et paiements",
          "content": "Plans d'abonnement : Le Service est proposé sur la base d'un abonnement. Les plans disponibles et les tarifs sont décrits sur notre page de tarification. Nous nous réservons le droit de modifier les fonctionnalités et les tarifs avec un préavis.\n\nFacturation : Les frais sont facturés à l'avance mensuellement ou annuellement. Les paiements sont traités par Stripe, Inc. En fournissant vos informations de paiement, vous autorisez Dashbal et Stripe à débiter les frais applicables.\n\nTaxes : Les prix s'entendent hors taxes, prélèvements et droits, y compris la TVA applicable. Vous êtes responsable de toutes les taxes applicables.\n\nRenouvellement automatique : Les abonnements se renouvellent automatiquement sauf annulation au moins 48 heures avant la fin de la période de facturation en cours. Vous pouvez annuler à tout moment dans les paramètres de votre compte.\n\nPolitique de remboursement : Tous les frais sont non remboursables sauf disposition contraire légale ou mention expresse dans notre politique de remboursement. Aucun remboursement n'est accordé pour les périodes de service partielles.\n\nModification des tarifs : Nous vous informerons au moins 30 jours avant toute augmentation de prix. La poursuite de l'utilisation du Service vaut acceptation des nouveaux tarifs.\n\nÉchec de paiement : En cas d'échec de paiement, nous pouvons suspendre l'accès aux fonctionnalités payantes jusqu'à régularisation.\n\nEssai gratuit : Le cas échéant, les essais gratuits sont réservés aux nouveaux utilisateurs, un seul par personne ou entité."
        },
        "usage": {
          "title": "5. Politique d'utilisation acceptable",
          "content": "Vous acceptez d'utiliser le Service uniquement à des fins légales. Vous vous engagez à ne pas :\n\n• Violer les lois, réglementations ou droits de tiers applicables\n• Tenter d'obtenir un accès non autorisé au Service, à d'autres comptes ou aux systèmes associés\n• Décompiler, désassembler ou effectuer de l'ingénierie inverse sur toute partie du Service\n• Introduire des codes malveillants, virus ou autres logiciels nuisibles\n• Utiliser des outils automatisés pour extraire ou surcharger le Service au-delà de son utilisation prévue\n• Usurper l'identité de Dashbal, de ses employés ou d'autres utilisateurs\n• Envoyer des communications commerciales non sollicitées (spam) via le Service\n• Contourner les contrôles d'accès, les limites d'utilisation ou les fonctions de sécurité\n• Utiliser le Service en violation des conditions des plateformes tierces (ex. : conditions d'API Shopify, Meta, TikTok)\n• Revendre, sous-licencier ou exploiter commercialement le Service sans notre consentement écrit préalable\n\nNous nous réservons le droit de suspendre ou de résilier l'accès sans préavis en cas de violation constatée."
        },
        "content": {
          "title": "6. Vos données et contenus",
          "content": "Votre propriété : Vous conservez la pleine propriété de toutes les données, contenus et informations que vous téléchargez, connectez ou soumettez via le Service (« Données Utilisateur »).\n\nLicence accordée à Dashbal : Vous accordez à Dashbal une licence limitée, non exclusive, libre de redevances et mondiale pour accéder, traiter, stocker et afficher vos Données Utilisateur uniquement pour : (a) fournir et maintenir le Service ; (b) répondre à vos demandes d'assistance ; et (c) respecter les obligations légales. Cette licence prend fin lorsque vous supprimez vos données ou clôturez votre compte.\n\nDonnées agrégées : Nous pouvons utiliser des données anonymisées, agrégées et dépersonnalisées à des fins d'amélioration produit et de recherche, sous réserve qu'elles ne permettent pas de vous identifier.\n\nExactitude des données : Vous êtes seul responsable de l'exactitude, de la qualité et de la légalité de vos Données Utilisateur et des moyens utilisés pour les obtenir auprès des plateformes tierces."
        },
        "ip": {
          "title": "7. Propriété intellectuelle",
          "content": "Propriété de Dashbal : Le Service — y compris tous les logiciels, algorithmes, interfaces utilisateur, designs, textes, graphiques, logos, marques et secrets commerciaux — est la propriété intellectuelle exclusive de Dashbal et de ses donneurs de licence, protégée par le droit d'auteur, les marques, les brevets et les autres lois applicables. Vous bénéficiez uniquement d'une licence limitée, non exclusive, non transférable et révocable d'utilisation du Service conformément aux présentes Conditions.\n\nRestrictions : Vous ne pouvez pas copier, modifier, distribuer, vendre, louer, sous-licencier ni créer des œuvres dérivées du Service sans notre consentement écrit préalable.\n\nRetours d'expérience : Toute suggestion, commentaire ou idée que vous nous communiquez est accordée à Dashbal de manière irrévocable, perpétuelle et sans redevance, sans obligation envers vous."
        },
        "ai": {
          "title": "8. Fonctionnalités IA et limitations",
          "content": "Le Service inclut des fonctionnalités d'intelligence artificielle et d'apprentissage automatique alimentées par des prestataires tiers (dont Google Gemini). Vous reconnaissez et acceptez que :\n\n• Les analyses, recommandations et insights générés par l'IA sont fournis à titre informatif uniquement et ne constituent pas des conseils financiers, juridiques, fiscaux, comptables ou professionnels de quelque nature que ce soit\n• Les résultats de l'IA peuvent contenir des erreurs ou des inexactitudes et ne doivent pas être utilisés comme seule base pour prendre des décisions commerciales\n• Vous êtes seul responsable de vérifier de manière indépendante les résultats générés par l'IA avant d'agir en conséquence\n• Nous nous réservons le droit de surveiller l'utilisation de l'IA pour garantir la conformité aux présentes Conditions et aux conditions des prestataires tiers\n• Le contenu soumis aux fonctionnalités IA peut être traité par des prestataires tiers selon leurs propres politiques de confidentialité\n\nAVERTISSEMENT : LES RÉSULTATS GÉNÉRÉS PAR L'IA SONT FOURNIS « EN L'ÉTAT » SANS AUCUNE GARANTIE D'EXACTITUDE, D'EXHAUSTIVITÉ OU D'ADÉQUATION À UN USAGE PARTICULIER. DASHBAL NE SAURAIT ÊTRE TENU RESPONSABLE DES DÉCISIONS PRISES SUR LA BASE DE CES RÉSULTATS."
        },
        "thirdParty": {
          "title": "9. Intégrations tierces",
          "content": "Le Service vous permet de connecter des plateformes tierces telles que Shopify, Meta (Facebook/Instagram), TikTok et WooCommerce. En connectant ces plateformes, vous :\n\n• Déclarez avoir le droit et l'autorité de connecter ces comptes et d'accorder les autorisations requises\n• Reconnaissez que votre utilisation de ces intégrations est soumise aux conditions générales des plateformes tierces concernées\n• Acceptez que Dashbal ne soit pas responsable de la disponibilité, de l'exactitude ou du contenu des plateformes tierces ou des sources de données\n• Comprenez que les modifications apportées aux API ou politiques des tiers peuvent affecter les fonctionnalités du Service, sans que Dashbal puisse être tenu responsable des perturbations, pertes de données ou dégradations de service en résultant\n\nDashbal ne cautionne pas les produits, services ou sites web tiers accessibles via le Service et n'en est pas responsable."
        },
        "termination": {
          "title": "10. Durée et résiliation",
          "content": "Résiliation par vous : Vous pouvez résilier votre compte à tout moment en nous contactant à support@dashbal.com ou via l'option de suppression de compte dans vos paramètres. La résiliation ne vous donne pas droit au remboursement des frais prépayés.\n\nRésiliation par Dashbal : Nous pouvons suspendre ou résilier votre accès immédiatement, sans préavis ni responsabilité, si :\n• Vous violez une disposition des présentes Conditions\n• Nous y sommes tenus par la loi ou une autorité réglementaire\n• Votre compte représente un risque pour la sécurité d'autres utilisateurs ou du Service\n• Nous mettons fin au Service (avec un préavis raisonnable dans la mesure du possible)\n\nEffet de la résiliation : À la résiliation, votre droit d'utiliser le Service prend fin immédiatement. Nous traiterons vos données conformément à notre Politique de Confidentialité. Les dispositions qui, par leur nature, survivent à la résiliation continuent de s'appliquer, notamment les droits de propriété intellectuelle, les exclusions de garanties, la limitation de responsabilité, l'indemnisation et la résolution des litiges."
        },
        "disclaimer": {
          "title": "11. Exclusion de garanties",
          "content": "LE SERVICE EST FOURNI « EN L'ÉTAT » ET « SELON LA DISPONIBILITÉ ». DANS LA MESURE MAXIMALE AUTORISÉE PAR LA LOI APPLICABLE, DASHBAL EXCLUT EXPRESSÉMENT TOUTES LES GARANTIES, EXPRESSES, IMPLICITES OU LÉGALES, Y COMPRIS, SANS S'Y LIMITER :\n\n• LES GARANTIES IMPLICITES DE QUALITÉ MARCHANDE, D'ADÉQUATION À UN USAGE PARTICULIER, DE TITRE ET DE NON-CONTREFAÇON\n• LES GARANTIES QUANT À L'EXACTITUDE, LA FIABILITÉ, L'EXHAUSTIVITÉ OU L'ACTUALITÉ DES DONNÉES PROVENANT DE SOURCES TIERCES (SHOPIFY, META, TIKTOK, WOOCOMMERCE)\n• LES GARANTIES QUE LE SERVICE SERA ININTERROMPU, SANS ERREUR, SÉCURISÉ OU EXEMPT DE VIRUS OU D'AUTRES COMPOSANTS NUISIBLES\n• LES GARANTIES RELATIVES AUX ANALYSES, PRÉVISIONS OU RECOMMANDATIONS GÉNÉRÉES PAR L'INTELLIGENCE ARTIFICIELLE\n\nCertaines juridictions n'autorisent pas l'exclusion de certaines garanties implicites. Dans ce cas, les exclusions ci-dessus s'appliquent dans la mesure maximale permise par la loi applicable."
        },
        "liability": {
          "title": "12. Limitation de responsabilité",
          "content": "DANS LA MESURE MAXIMALE AUTORISÉE PAR LA LOI APPLICABLE :\n\n(A) EN AUCUN CAS DASHBAL, SES DIRIGEANTS, ADMINISTRATEURS, EMPLOYÉS, AGENTS, PARTENAIRES OU CONCÉDANTS NE POURRONT ÊTRE TENUS RESPONSABLES DE DOMMAGES INDIRECTS, ACCESSOIRES, SPÉCIAUX, CONSÉCUTIFS, PUNITIFS OU EXEMPLAIRES, Y COMPRIS LES PERTES DE PROFITS, DE REVENUS, DE DONNÉES, DE CLIENTÈLE, D'OPPORTUNITÉS COMMERCIALES OU D'EXPLOITATION, MÊME S'ILS ONT ÉTÉ INFORMÉS DE LA POSSIBILITÉ DE TELS DOMMAGES.\n\n(B) LA RESPONSABILITÉ TOTALE CUMULÉE DE DASHBAL ENVERS VOUS POUR TOUTES LES RÉCLAMATIONS LIÉES AUX PRÉSENTES CONDITIONS OU AU SERVICE NE DÉPASSERA PAS : (I) LE MONTANT TOTAL DES FRAIS QUE VOUS AVEZ PAYÉS À DASHBAL AU COURS DES DOUZE (12) MOIS PRÉCÉDANT LA RÉCLAMATION ; OU (II) CENT DOLLARS AMÉRICAINS (100 USD), LE MONTANT LE PLUS ÉLEVÉ ÉTANT RETENU.\n\n(C) CES LIMITATIONS S'APPLIQUENT QUELLE QUE SOIT LA THÉORIE DE RESPONSABILITÉ (CONTRAT, DÉLIT, NÉGLIGENCE, RESPONSABILITÉ STRICTE OU AUTRE) ET MÊME SI UN RECOURS LIMITÉ A FAILLI À SON OBJECTIF ESSENTIEL.\n\nCertaines juridictions n'autorisent pas certaines limitations de responsabilité. Dans ce cas, les limitations ci-dessus s'appliquent dans la mesure maximale permise par la loi applicable."
        },
        "indemnification": {
          "title": "13. Indemnisation",
          "content": "Vous acceptez de défendre, d'indemniser et de tenir indemnes Dashbal et ses dirigeants, administrateurs, employés, sous-traitants, agents, concédants et successeurs (« Personnes Indemnisées de Dashbal ») contre toute réclamation, dommage, perte, responsabilité, coût et dépense (y compris les honoraires d'avocats raisonnables) de tiers découlant de ou liés à :\n\n• Votre utilisation du Service ou votre incapacité à l'utiliser\n• Vos Données Utilisateur ou contenus soumis via le Service\n• Votre violation des présentes Conditions ou de toute loi ou réglementation applicable\n• Votre violation des droits de tiers, y compris les droits de propriété intellectuelle ou de vie privée\n• Toute fausse déclaration que vous auriez faite\n• Votre violation des déclarations ou garanties contenues dans les présentes Conditions\n\nDashbal se réserve le droit de prendre en charge la défense de toute réclamation sujette à indemnisation de votre part (à vos frais), et vous acceptez de coopérer pleinement à notre défense."
        },
        "governing": {
          "title": "14. Loi applicable et résolution des litiges",
          "content": "Loi applicable : Les présentes Conditions sont régies et interprétées conformément aux lois de la juridiction dans laquelle Dashbal est dûment constitué, sans égard aux dispositions relatives aux conflits de lois. La Convention des Nations Unies sur les contrats de vente internationale de marchandises (CVIM) ne s'applique pas.\n\nRésolution amiable : Avant toute procédure formelle, vous vous engagez à nous contacter à support@dashbal.com et à tenter de résoudre le litige à l'amiable pendant au moins 30 jours.\n\nJuridiction : Pour les litiges non résolus à l'amiable, les parties se soumettent à la compétence exclusive des tribunaux compétents de la juridiction où Dashbal est enregistré.\n\nDroits des consommateurs de l'UE : Pour les utilisateurs situés dans l'Union Européenne, les présentes Conditions ne portent pas atteinte à vos droits en tant que consommateur en vertu du droit impératif de l'UE, y compris votre droit de saisir les tribunaux de votre pays de domicile.\n\nRenonciation aux actions collectives : Dans la mesure permise par la loi applicable, vous renoncez à tout droit de participer à ou d'initier une action collective contre Dashbal."
        },
        "general": {
          "title": "15. Dispositions générales",
          "content": "Intégralité de l'accord : Les présentes Conditions, ainsi que notre Politique de Confidentialité et tout accord complémentaire, constituent l'accord intégral entre vous et Dashbal concernant le Service.\n\nDivisibilité : Si une disposition des présentes Conditions est jugée inapplicable ou invalide, cette disposition sera modifiée au minimum nécessaire, et les autres dispositions resteront en pleine vigueur.\n\nRenonciation : Notre manquement à faire respecter un droit ou une disposition des présentes Conditions ne constitue pas une renonciation à ce droit.\n\nCession : Vous ne pouvez pas céder vos droits en vertu des présentes Conditions sans notre consentement écrit préalable. Dashbal peut céder les présentes Conditions sans restriction.\n\nForce majeure : Dashbal ne saurait être tenu responsable des retards ou manquements résultant de causes indépendantes de notre volonté raisonnable, notamment les catastrophes naturelles, les actes gouvernementaux, les cyberattaques ou les défaillances de services tiers.\n\nNotifications : Les notifications à Dashbal doivent être envoyées à support@dashbal.com. Les notifications à vous seront envoyées à l'adresse email associée à votre compte."
        },
        "changes": {
          "title": "16. Modifications des conditions",
          "content": "Nous nous réservons le droit de modifier les présentes Conditions à tout moment. En cas de modification substantielle, nous vous en informerons au moins 30 jours avant l'entrée en vigueur des nouvelles Conditions — par email à votre adresse enregistrée et/ou par un avis bien visible sur notre site web.\n\nVotre poursuite d'utilisation du Service après l'entrée en vigueur des nouvelles Conditions vaut acceptation de celles-ci. Si vous n'acceptez pas les nouvelles Conditions, vous devez cesser d'utiliser le Service avant leur date d'entrée en vigueur."
        },
        "contact": {
          "title": "17. Nous contacter",
          "content": "Pour toute question relative aux présentes Conditions d'Utilisation, veuillez contacter :\n\nÉquipe Support Dashbal\nEmail : support@dashbal.com\nSite web : https://dashbal.com/terms\n\nPour les questions relatives à la confidentialité : privacy@dashbal.com"
        }
      }
    },
    "privacy": {
      "title": "Politique de Confidentialité",
      "sections": {
        "intro": {
          "title": "1. Introduction",
          "content": "Dashbal (« nous », « notre » ou « nos ») s'engage à protéger vos données personnelles et à respecter votre vie privée, conformément au Règlement Général sur la Protection des Données (RGPD) et aux lois applicables. La présente Politique de Confidentialité explique comment nous collectons, utilisons, stockons, partageons et protégeons vos informations lorsque vous accédez ou utilisez la plateforme Dashbal, le site web et les services associés (collectivement, le « Service »).\n\nEn vous inscrivant ou en utilisant le Service, vous reconnaissez avoir lu et compris la présente Politique de Confidentialité. Si vous n'acceptez pas, veuillez ne pas utiliser le Service.\n\nResponsable du traitement : Dashbal\nContact Confidentialité : privacy@dashbal.com"
        },
        "collection": {
          "title": "2. Informations que nous collectons",
          "content": "Nous collectons les catégories suivantes de données personnelles :\n\nDonnées de compte et d'identité\n• Nom, adresse email et mot de passe chiffré\n• Identifiants de connexion sociale (Google, Facebook, Apple, TikTok)\n• Pays, fuseau horaire et préférences de devise\n\nDonnées commerciales et de canaux\n• Données des plateformes connectées (Shopify, WooCommerce, Meta, TikTok) : commandes, transactions, produits, métriques publicitaires, données de campagne\n• Jetons d'accès OAuth et identifiants API (chiffrés au repos)\n\nDonnées financières et de facturation\n• Statut d'abonnement, informations sur le plan et historique de facturation\n• Paiements traités par Stripe (nous ne stockons pas les numéros de carte complets)\n\nDonnées d'utilisation et d'activité\n• Interactions avec les fonctionnalités, événements de session et événements analytiques\n• Adresse IP, type de navigateur, système d'exploitation et agent utilisateur\n• Journaux d'activité complets avec horodatage de toutes les actions\n\nDonnées IA et documents\n• Contenu soumis aux fonctionnalités d'analyse IA\n• Journaux d'utilisation IA incluant les comptages de tokens\n• Documents téléchargés pour analyse (traités via Microsoft Azure)\n\nDonnées de communication\n• Métriques d'engagement email (ouvertures, clics)\n• Communications avec le support client"
        },
        "legalBasis": {
          "title": "3. Base juridique du traitement (RGPD)",
          "content": "Si vous êtes situé dans l'Espace Économique Européen (EEE), au Royaume-Uni ou en Suisse, nous traitons vos données personnelles sur les bases juridiques suivantes, conformément à l'Article 6 du RGPD :\n\n• Exécution d'un contrat (Art. 6(1)(b)) : Traitement nécessaire pour fournir le Service, gérer votre compte, traiter les paiements et exécuter notre contrat avec vous.\n\n• Intérêt légitime (Art. 6(1)(f)) : Sécurité du Service et prévention des fraudes, amélioration du produit, journaux d'activité et analyses — lorsque nos intérêts légitimes ne prévalent pas sur vos droits et libertés fondamentaux.\n\n• Consentement (Art. 6(1)(a)) : Pour les cookies non essentiels et les communications marketing optionnelles. Vous pouvez retirer votre consentement à tout moment, sans que cela n'affecte la licéité du traitement antérieur.\n\n• Obligation légale (Art. 6(1)(c)) : Lorsque nous sommes tenus de nous conformer aux lois applicables, aux réglementations fiscales, aux obligations comptables ou aux procédures légales."
        },
        "usage": {
          "title": "4. Utilisation de vos informations",
          "content": "Nous utilisons les informations collectées pour :\n\n• Fournir, exploiter et maintenir le Service\n• Vous authentifier et gérer la sécurité des sessions\n• Traiter les paiements et gérer votre abonnement\n• Agréger et afficher les analyses de vos canaux connectés\n• Alimenter les analyses IA et les fonctionnalités d'analyse de documents\n• Envoyer des emails transactionnels, alertes de sécurité et communications d'assistance\n• Surveiller les abus, fraudes et menaces de sécurité\n• Améliorer et développer de nouvelles fonctionnalités (en utilisant des données agrégées et anonymisées)\n• Respecter les obligations légales et faire respecter nos CGU\n\nConformément à l'Article 22 du RGPD, nous n'utilisons pas vos données personnelles pour des prises de décisions entièrement automatisées produisant des effets juridiques ou similaires importants sans examen humain."
        },
        "sharing": {
          "title": "5. Partage de données et sous-traitants",
          "content": "Nous ne vendons pas vos données personnelles. Nous pouvons partager des données uniquement comme suit :\n\nPrestataires de services (Sous-traitants liés par des accords de traitement de données conformes à l'Art. 28 RGPD) :\n• Stripe, Inc. — Traitement des paiements et facturation\n• Google LLC (API Gemini) — Analyses et insights générés par IA\n• Microsoft Azure (Document Intelligence & Blob Storage) — Analyse de documents et stockage sécurisé de fichiers\n• Resend — Envoi d'emails transactionnels\n• ipinfo.io — Géolocalisation basée sur l'adresse IP\n• Fournisseur d'infrastructure cloud — Hébergement de bases de données et infrastructure serveur\n\nAPI de plateformes tierces (à l'initiative de l'utilisateur uniquement) :\n• Shopify, Meta (Facebook/Instagram), TikTok, WooCommerce — Les données sont récupérées uniquement en votre nom depuis les plateformes que vous connectez explicitement.\n\nDivulgations légales :\nNous pouvons divulguer vos informations si la loi, une ordonnance judiciaire ou la protection des droits de Dashbal, de nos utilisateurs ou du public l'exige.\n\nTransferts d'activité :\nEn cas de fusion, acquisition ou cession d'actifs, vos données peuvent être transférées. Nous vous en informerons préalablement.\n\nTous nos sous-traitants sont contractuellement tenus de garantir un niveau de protection des données équivalent."
        },
        "storage": {
          "title": "6. Sécurité des données",
          "content": "Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles conformes aux standards du secteur, notamment :\n\n• Chiffrement AES-256 des identifiants sensibles et jetons OAuth au repos\n• Hachage des mots de passe avec bcrypt et facteur de coût adaptatif\n• Jetons d'accès JWT à durée de vie limitée (expiration en 15 minutes) avec jetons de rafraîchissement sécurisés\n• Chiffrement HTTPS/TLS pour toutes les données en transit\n• Limitation de débit et protection contre les attaques par force brute\n• Protection CSRF via des jetons d'état à durée limitée\n• En-têtes de sécurité HTTP (Helmet.js)\n• Journaux d'audit complets de toutes les actions utilisateur et système\n\nMalgré ces mesures, aucun système n'est à l'abri des violations de sécurité. En cas de violation affectant vos droits et libertés, nous vous en informerons, ainsi que les autorités de contrôle compétentes, dans les délais requis par la loi applicable (72 heures pour le RGPD, Art. 33)."
        },
        "retention": {
          "title": "7. Conservation des données",
          "content": "Nous conservons les données personnelles pour les durées suivantes :\n\n• Données de compte : Conservées pendant la durée d'activité du compte, puis jusqu'à 90 jours après la suppression pour permettre la récupération et respecter les obligations légales\n• Enregistrements de transactions et de facturation : Conservés 7 ans pour respecter les obligations comptables et fiscales\n• Journaux d'activité et d'accès : Conservés jusqu'à 12 mois, puis purgés automatiquement\n• Événements d'analyse : Conservés jusqu'à 24 mois\n• Journaux d'utilisation IA : Conservés jusqu'à 12 mois\n• Données d'engagement email : Conservées jusqu'à 24 mois\n\nÀ la suppression du compte, les données personnelles sont supprimées ou anonymisées, sauf obligation légale de conservation. Vous pouvez demander la suppression anticipée de vos données en contactant privacy@dashbal.com."
        },
        "cookies": {
          "title": "8. Cookies et technologies de suivi",
          "content": "Nous utilisons des cookies et des technologies similaires pour exploiter et améliorer le Service :\n\nCookies essentiels : Nécessaires pour l'authentification, la gestion des sessions et les fonctionnalités principales. Ils ne peuvent pas être désactivés car indispensables au bon fonctionnement du Service.\n\nCookies analytiques : Nous aident à comprendre comment les utilisateurs interagissent avec le Service. Les données collectées sont agrégées et anonymisées dans la mesure du possible.\n\nCookies de préférences : Mémorisent vos paramètres et préférences (langue, thème, options d'affichage).\n\nCookies marketing : Utilisés uniquement avec votre consentement préalable explicite.\n\nVous pouvez gérer vos préférences cookies à tout moment via les Paramètres des Cookies sur notre site web. Le retrait du consentement pour les cookies non essentiels peut limiter certaines fonctionnalités.\n\nConformément aux recommandations de la CNIL, notre interface de consentement aux cookies propose les options « Tout accepter » et « Tout refuser » avec une visibilité équivalente, ainsi qu'une option « Gérer mes préférences »."
        },
        "rights": {
          "title": "9. Vos droits sur vos données",
          "content": "En fonction de votre localisation, vous disposez des droits suivants :\n\nUE/EEE, Royaume-Uni et Suisse (RGPD / UK GDPR) :\n• Droit d'accès (Art. 15 RGPD) : Obtenir une copie de vos données personnelles\n• Droit de rectification (Art. 16 RGPD) : Corriger des données inexactes ou incomplètes\n• Droit à l'effacement — « Droit à l'oubli » (Art. 17 RGPD) : Demander la suppression de vos données\n• Droit à la portabilité des données (Art. 20 RGPD) : Recevoir vos données dans un format structuré, couramment utilisé et lisible par machine\n• Droit à la limitation du traitement (Art. 18 RGPD) : Demander la suspension temporaire du traitement de vos données\n• Droit d'opposition (Art. 21 RGPD) : Vous opposer au traitement fondé sur l'intérêt légitime\n• Droit de déposer une réclamation : Auprès de votre autorité de protection des données (CNIL en France : www.cnil.fr ; ICO au Royaume-Uni : ico.org.uk)\n\nRésidents de Californie (CCPA/CPRA) :\n• Droit de savoir : Catégories et éléments spécifiques d'informations personnelles collectés\n• Droit de suppression : Demander la suppression de vos informations personnelles\n• Droit de correction : Demander la rectification d'informations inexactes\n• Droit d'opposition à la vente : Nous ne vendons ni ne partageons vos données à des fins de publicité comportementale\n• Droit à la non-discrimination pour l'exercice de vos droits\n\nRésidents canadiens (PIPEDA / Loi 25 du Québec) :\n• Droit d'accès, de rectification et de retrait du consentement pour le traitement non essentiel\n• Les résidents du Québec disposent d'un droit supplémentaire de désindexation de certaines informations personnelles\n\nPour exercer ces droits, contactez-nous à privacy@dashbal.com. Nous répondrons dans un délai de 30 jours (ou dans le délai requis par la loi applicable)."
        },
        "international": {
          "title": "10. Transferts internationaux de données",
          "content": "Dashbal opère à l'échelle mondiale et vos données peuvent être transférées et traitées dans des pays autres que votre pays de résidence, y compris des pays n'offrant pas le même niveau de protection des données.\n\nLorsque nous transférons des données personnelles depuis l'Espace Économique Européen, le Royaume-Uni ou la Suisse vers des pays tiers, nous utilisons les garanties appropriées suivantes :\n\n• Cadre de protection des données UE–États-Unis (DPF) : Le cas échéant, nous nous appuyons sur la décision d'adéquation adoptée par la Commission européenne le 10 juillet 2023 pour les transferts vers les sous-traitants américains certifiés DPF.\n\n• Clauses Contractuelles Types (CCT) : Pour les transferts non couverts par le DPF, nous utilisons les Clauses Contractuelles Types adoptées en vertu de la Décision d'Exécution (UE) 2021/914 de la Commission du 4 juin 2021.\n\n• Accords de transfert de données internationaux (IDTA) : Pour les transferts depuis le Royaume-Uni, nous utilisons l'IDTA approuvé par le Secrétaire d'État britannique ou les CCT de l'UE avec l'addendum britannique (conformément à l'article 119A du Data Protection Act 2018).\n\n• Analyses d'impact des transferts (TIA) : Nous réalisons des analyses d'impact là où elles sont requises pour compléter ces mécanismes.\n\nEn utilisant le Service, vous reconnaissez que vos données peuvent faire l'objet de transferts internationaux conformément aux garanties décrites ci-dessus."
        },
        "children": {
          "title": "11. Protection des mineurs",
          "content": "Le Service est exclusivement destiné aux utilisateurs âgés de 18 ans et plus. Nous ne collectons pas sciemment de données personnelles de personnes de moins de 18 ans.\n\nSi nous constatons avoir collecté des données d'un mineur sans consentement parental vérifiable, nous les supprimerons immédiatement.\n\nSi vous êtes un parent ou tuteur et pensez que votre enfant nous a communiqué des données personnelles, veuillez nous contacter à privacy@dashbal.com."
        },
        "changes": {
          "title": "12. Modifications de la présente politique",
          "content": "Nous pouvons mettre à jour la présente Politique de Confidentialité de temps à autre pour refléter des changements dans nos pratiques, technologies, exigences légales ou d'autres facteurs.\n\nPour les modifications substantielles, nous vous en informerons au moins 30 jours avant leur entrée en vigueur par :\n• Envoi d'un email à l'adresse associée à votre compte\n• Affichage d'un avis bien visible sur notre site web\n\nVotre poursuite d'utilisation du Service après l'entrée en vigueur de la politique révisée vaut acceptation des changements. Si vous n'acceptez pas les changements, vous devez cesser d'utiliser le Service avant leur date d'entrée en vigueur."
        },
        "contact": {
          "title": "13. Nous contacter",
          "content": "Pour toute question, demande ou préoccupation concernant la présente Politique de Confidentialité ou nos pratiques en matière de données, veuillez contacter :\n\nÉquipe Protection des Données\nEmail : privacy@dashbal.com\nSite web : https://dashbal.com/privacy\n\nSi vous êtes situé dans l'UE/EEE et n'êtes pas satisfait de notre réponse, vous avez le droit de déposer une réclamation auprès de votre autorité nationale de protection des données (CNIL en France : www.cnil.fr ; ICO au Royaume-Uni : ico.org.uk)."
        }
      }
    }
  },
  "gdpr": {
    "banner": {
      "title": "Nous respectons votre vie privée",
      "description": "Nous utilisons des cookies pour vous offrir la meilleure expérience possible. Certains cookies sont essentiels, tandis que d'autres nous aident à améliorer votre expérience.",
      "learnMore": "En savoir plus",
      "acceptAll": "Tout accepter",
      "rejectAll": "Tout refuser",
      "customize": "Personnaliser"
    },
    "preferences": {
      "title": "Préférences de cookies",
      "description": "Gérez vos préférences en matière de cookies. Vous pouvez activer ou désactiver différentes catégories ci-dessous.",
      "savePreferences": "Enregistrer les préférences"
    },
    "categories": {
      "necessary": {
        "title": "Cookies essentiels",
        "description": "Ces cookies sont requis pour le fonctionnement de base du site, comme la navigation et l'accès sécurisé."
      },
      "analytics": {
        "title": "Cookies analytiques",
        "description": "Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site web."
      },
      "marketing": {
        "title": "Cookies marketing",
        "description": "Ces cookies sont utilisés pour suivre les visiteurs sur les sites web afin d'afficher des publicités pertinentes."
      },
      "preferences": {
        "title": "Cookies de préférences",
        "description": "Ces cookies permettent au site de se souvenir de vos choix (comme la langue)."
      }
    },
    "required": "Requis",
    "managePreferences": "Paramètres des cookies"
  },
  "sync": {
    "connecting": "Connexion...",
    "authenticating": "Authentification...",
    "requesting_data": "Demande données...",
    "waiting": "En attente...",
    "receiving": "Réception...",
    "verifying": "Vérification...",
    "analyzing": "Analyse...",
    "processing": "Traitement...",
    "mapping": "Indexation...",
    "finalizing": "Finalisation...",
    "analyzing_customers": "Analyse clients...",
    "detecting_currencies": "Détection devises...",
    "calculating_ranges": "Calcul plages...",
    "syncing_data": "Synchronisation...",
    "fetching_data": "Récupération...",
    "querying_api": "Requête API...",
    "retrieving": "Récupération..."
  },
  "entityTypes": {
    "adaccount": "Compte publicitaire",
    "campaign": "Campagne",
    "adset": "Ensemble de publicités",
    "adgroup": "Groupe de publicités",
    "ad": "Publicité",
    "product": "Produit",
    "coupon": "Coupon",
    "campaign_one": "campagne",
    "campaign_other": "campagnes",
    "adaccount_one": "compte publicitaire",
    "adaccount_other": "comptes publicitaires",
    "adset_one": "ensemble de publicités",
    "adset_other": "ensembles de publicités",
    "adgroup_one": "groupe de publicités",
    "adgroup_other": "groupes de publicités",
    "ad_one": "publicité",
    "ad_other": "publicités",
    "product_one": "produit",
    "product_other": "produits",
    "coupon_one": "coupon",
    "coupon_other": "coupons"
  },
  "channelEvents": {
    "shopify": {
      "product": {
        "updated": "Produit Mis à Jour",
        "destroyed": "Produit Supprimé",
        "published": "Produit Publié",
        "unpublished": "Produit Retiré",
        "status_changed": "Statut du Produit Modifié"
      },
      "order": {
        "placed": "Commande Passée",
        "confirmed": "Commande Confirmée",
        "cancelled": "Commande Annulée",
        "closed": "Commande Clôturée",
        "reopened": "Commande Rouverte",
        "fulfilled": "Commande Expédiée",
        "fulfillment_cancelled": "Expédition Annulée",
        "refund_success": "Remboursement Effectué"
      },
      "collection": {
        "updated": "Collection Mise à Jour",
        "destroyed": "Collection Supprimée",
        "published": "Collection Publiée",
        "unpublished": "Collection Retirée"
      },
      "article": {
        "updated": "Article Mis à Jour",
        "destroyed": "Article Supprimé"
      },
      "blog": {
        "updated": "Blog Mis à Jour",
        "destroyed": "Blog Supprimé"
      },
      "page": {
        "updated": "Page Mise à Jour",
        "destroyed": "Page Supprimée"
      },
      "price_rule": {
        "updated": "Remise Modifiée",
        "destroyed": "Remise Supprimée"
      }
    },
    "meta": {
      "campaign": {
        "status_updated": "Statut de Campagne Modifié",
        "budget_updated": "Budget de Campagne Modifié",
        "schedule_updated": "Calendrier de Campagne Modifié",
        "ended": "Campagne Terminée",
        "spend_cap_updated": "Plafond de Dépenses Modifié"
      },
      "adset": {
        "status_updated": "Statut de l'Ensemble de Pub Modifié",
        "budget_updated": "Budget de l'Ensemble de Pub Modifié",
        "bidding_updated": "Enchères de l'Ensemble de Pub Modifiées",
        "bid_strategy_updated": "Stratégie d'Enchères Modifiée",
        "targeting_updated": "Ciblage de l'Ensemble de Pub Modifié",
        "schedule_updated": "Calendrier de l'Ensemble de Pub Modifié"
      },
      "ad": {
        "status_updated": "Statut de la Pub Modifié",
        "creative_updated": "Créatif Pub Modifié",
        "review_approved": "Pub Approuvée",
        "review_declined": "Pub Refusée"
      },
      "account": {
        "status_updated": "Statut du Compte Modifié",
        "spend_limit_updated": "Limite de Dépenses Modifiée",
        "spend_limit_reset": "Limite de Dépenses Réinitialisée",
        "spend_limit_removed": "Limite de Dépenses Supprimée"
      }
    },
    "unknown": "Événement"
  },
  "upgrade": {
    "defaultTitle": "Limite de Plan Atteinte",
    "defaultDescription": "Mettez à jour votre plan pour en débloquer davantage.",
    "currentPlan": "Actuel",
    "usage": "Utilisation",
    "dismiss": "Plus tard",
    "noSubscription": "Aucun abonnement actif",
    "cta": "Voir les Plans"
  },
  "pages": {
    "traffic": {
      "title": "Attribution du Trafic",
      "subtitle": "Analysez comment chaque canal contribue à votre revenu total.",
      "aiDiagnosis": "Analyse du Trafic IA",
      "trafficVerdict": "Verdict d'Attribution",
      "topRecommendation": "Opportunité de Croissance",
      "applyOptimization": "Scaler le Canal",
      "verdictPlaceholder": "Votre attribution <0>{{channel}}</0> a augmenté de <1>{{percent}}%</1> sur cette période. C'est actuellement votre source la plus efficace.",
      "recommendationPlaceholder": "Augmenter les dépenses publicitaires sociales de 15% pourrait générer environ {{revenue}} de revenu supplémentaire.",
      "kpis": {
        "totalRevenue": "Revenu Total",
        "organicRevenue": "Revenu Organique",
        "paidRevenue": "Revenu Payant",
        "conversionRate": "Taux Conv.",
        "topChannel": "Top Canal"
      },
      "table": {
        "source": "Source de trafic",
        "attribution": "% d'attribution",
        "revenue": "Revenu",
        "trend": "Tendance",
        "availableStreams": "Flux Disponibles",
        "volume": "Volume",
        "action": "Action",
        "performanceSource": "Source de Performance",
        "revenueValue": "Valeur du Revenu",
        "sharePercent": "% de Part",
        "connectivityStatus": "Statut de Connectivité",
        "paid": "Payant",
        "organic": "Organique",
        "noDataLinkAnalysis": "Aucune donnée disponible pour l'analyse des liens",
        "metrics": "Métriques",
        "total": "TOTAL",
        "periodTotal": "TOTAL PÉRIODE",
        "attributionLabel": "Attribution"
      },
      "activeFocus": "Focus Actif",
      "distribution": "Répartition des Revenus",
      "periodDistribution": "Répartition des Revenus de la Période",
      "modals": {
        "organicTitle": "Performance Organique",
        "organicDescription": "Ce revenu est généré à partir de vos sources organiques et est automatiquement intégré à votre tableau de bord.",
        "platformLinkTitle": "Lien Plateforme",
        "platformLinkDescription": "{{name}} représente {{percent}}% de ce revenu. Une limitation de la source empêche actuellement le lien direct vers cette campagne spécifique.",
        "unavailableTooltip": "(indisponible, connecter ?)",
        "generalSales": "Ventes Générales",
        "unmatchedSource": "{{source}} non associé",
        "unmatchedSourceWithId": "{{source}} non associé (ID:{{id}})",
        "untrackedLabel": "Non suivi",
        "unknownSourceLabel": "Source inconnue",
        "unknownChannel": "Inconnu",
        "directOrganic": "Direct / Organique",
        "disconnectedLabel": "est déconnecté"
      },
      "totalSourceRevenue": "Revenu total de la source"
    },
    "cashflow": {
      "title": "Trésorerie",
      "dailyBreakdown": "Répartition Quotidienne",
      "kpis": {
        "netProfit": "Flux de Trésorerie Net",
        "mer": "MER (ROAS Global)",
        "avgDaily": "Moy. Quotidienne Nette",
        "opex": "OpEx Totales"
      },
      "verdict": {
        "title": "Verdict de Trésorerie",
        "subtitle": "Analyse Stratégique",
        "positive": "Votre entreprise est actuellement en <0>Trésorerie Positive</0>. Avec un MER de <1>{{mer}}x</1>, vous avez de la marge pour optimiser l'efficacité.",
        "negative": "Votre entreprise est actuellement en <0>Trésorerie Négative</0>. Concentrez-vous sur la réduction des OpEx non essentiels.",
        "recommendationPositive": "Visez une augmentation de 10% du ROAS pour capter plus de volume.",
        "recommendationNegative": "Renégociez les conditions fournisseurs pour une meilleure trésorerie.",
        "mobilePositive": "Votre entreprise est actuellement en <0>Trésorerie Positive</0>. Avec un MER de <1>{{mer}}x</1>, vous avez de la marge pour croître.",
        "mobileNegative": "Votre entreprise est actuellement en <0>Trésorerie Négative</0>. Concentrez-vous sur l'efficacité.",
        "mobileRecPositive": "Scalez les canaux les plus performants.",
        "mobileRecNegative": "Optimisez les dépenses opérationnelles."
      }
    },
    "forecast": {
      "title": "Prévisions",
      "empty": {
        "title": "Collecte de données historiques",
        "description": "Les prévisions nécessitent une base de performance historique. Connectez votre boutique et vos canaux marketing pour commencer à visualiser vos futurs modèles.",
        "monitoring": "Signaux de surveillance",
        "notEnoughData": "Pas assez de données",
        "needMoreHistory": "Nous avons besoin de plus d'historique de données pour ce produit pour générer des prévisions fiables.",
        "notYesterdayTitle": "Ajustement de votre vue",
        "notYesterdayDescription": "Les prévisions ne sont disponibles que lorsque vous analysez des données allant jusqu'à hier pour garantir la finalité des données. Veuillez ajuster votre plage de dates.",
        "noDataTitle": "Données insuffisantes pour les prévisions",
        "noDataDescription": "Nous n'avons pas assez de données historiques pour générer une prévision fiable. Connectez plus de sources ou attendez que plus de données soient accumulées."
      },
      "distribution": {
        "title": "Répartition des revenus (Prévus)"
      },
      "controls": {
        "historical": "Historique :",
        "forecast": "Prévisions :",
        "window": "Fenêtre de prévision",
        "debug": "Débogage des graphiques"
      },
      "kpis": {
        "forecastedRevenue": "Revenu prévu",
        "statisticalAccuracy": "Précision statistique",
        "expectedTotal": "Total attendu"
      },
      "sources": {
        "title": "Sources prévues",
        "paidSuffix": " - Payant",
        "forecast": "Prévisions"
      },
      "charts": {
        "predictedRevenue": "Revenu prédit",
        "roas": "ROAS",
        "actualRoas": "ROAS Actuel",
        "predictedRoas": "ROAS Prédit",
        "upperBound": "Borne supérieure",
        "lowerBound": "Borne inférieure",
        "actualRevenue": "Revenu Actuel",
        "forecast": "Prévisions",
        "actualValue": "Valeur actuelle",
        "predictedValue": "Valeur prédite",
        "bottomUpTransformation": "Transformation Ascendante",
        "accurateSummation": "Sommation précise",
        "combinedRevenue": "Revenu total combiné",
        "revenueTransformationDesc": "Généré en transformant les cibles de ROAS par source en revenus basés sur les cibles de dépenses manuelles et les tendances organiques. Reflète tous les ajustements d'optimisme et de volatilité.",
        "totalCostOperations": "Coût total des opérations",
        "actualExpense": "Dépense actuelle",
        "predictedExpense": "Dépense prédite",
        "expenseAggregateDesc": "Agrégat de toutes les dépenses marketing, écritures de journal, spécifications calculées (taxes/frais) et dépenses générales opérationnelles. Inclut la saisonnalité et le jitter adaptatif pour le réalisme.",
        "nonPaidForecasts": "Prévisions de revenus non payants",
        "unknownSourceRevenue": "Revenu de source inconnue",
        "combinedRoasTrajectory": "Trajectoire ROAS combinée",
        "combinedNonPaidRevenue": "Revenu non payant combiné",
        "manualEntries": "Entrées manuelles",
        "boardSpecs": "Spécifications du board",
        "untrackedLabel": "Non suivi / Déconnecté",
        "forecastedRevenue": "Revenu prévu"
      },
      "sections": {
        "nonPaidRevenue": "Prévisions de revenus non payants"
      },
      "verdict": {
        "title": "Verdict de prédiction",
        "growth": "Croissance attendue",
        "steady": "Trajectoire stable",
        "summary": "Basé sur {{count}} jours de données, revenu projeté : {{revenue}} sur {{days}} jours.",
        "varianceRange": "Plage de variance attendue",
        "variance": "Plage de variance attendue",
        "margin": "±{{percent}}% de marge",
        "pessimistic": "Estimation pessimiste",
        "optimistic": "Estimation optimiste"
      },
      "product": {
        "stats": "Statistiques de {{name}}",
        "revenueForecast": "Prévisions de revenus",
        "revenueProjection": "Projection de revenus",
        "noRevenueData": "Aucune donnée de revenu trouvée",
        "noRevenueDataDesc": "Ce produit n'a pas encore assez de revenus suivis pour générer des prévisions. Les revenus apparaîtront au fur et à mesure que les données sont enregistrées.",
        "noDetailedData": "Pas de données détaillées",
        "noDetailedDataDesc": "Impossible de mapper des campagnes suivies à cette source de revenus.",
        "noRevenueDataAvailable": "Aucune donnée de revenu disponible",
        "noRevenueDataAvailableDesc": "Pas assez de données de dépenses ou de revenus liées à cette source publicitaire pour calculer des prévisions de revenus.",
        "noOrganicData": "Aucune donnée de revenu organique",
        "noOrganicDataDesc": "Ce produit n'a pas encore généré assez de revenus organiques pour des prévisions fiables.",
        "organicRevenue": "Revenu organique ({{source}})",
        "revenueForecastTitle": "Prévision de revenus ({{source}})",
        "accuracy": "{{percent}}% de précision",
        "limitedData": "Données limitées",
        "forecast": "Prévisions"
      },
      "accuracy": {
        "title": "Précision statistique",
        "reliabilityLabel": "Fiabilité des prévisions",
        "percentage": "{{score}}% de précision",
        "verdicts": {
          "good": "Bonne — Assez de données stables pour produire une prévision significative.",
          "moderate": "Modérée — Quelques lacunes de données. Traiter comme une estimation directionnelle approximative.",
          "low": "Faible — Données très limitées. Cette prévision est une estimation au mieux, pas une prédiction fiable."
        },
        "backtest": {
          "label": "Rétro-test",
          "title": "Rétro-test historique",
          "body": "Dans quelle mesure notre modèle prédit les données historiques récentes. Plus c'est élevé, mieux c'est."
        },
        "quality": {
          "label": "Qualité des données",
          "title": "Intégrité des données",
          "body": "Mesure les lacunes et les valeurs aberrantes dans vos données de revenus historiques."
        },
        "fidelity": {
          "label": "Fidélité du curseur",
          "title": "Impact de l'ajustement",
          "body": "Dans quelle mesure vos ajustements manuels des curseurs s'écartent de la ligne de base de l'IA."
        },
        "horizon": {
          "label": "Horizon",
          "title": "Horizon de prévision",
          "body": "La précision décroît naturellement à mesure que nous regardons plus loin dans le futur."
        },
        "coverage": {
          "label": "Couverture",
          "title": "Couverture des sources",
          "body": "Pourcentage de sources de revenus qui ont assez de données pour être modélisées statistiquement."
        },
        "sources": {
          "title": "Sources testées",
          "body": "Nombre de sources de revenus avec assez d'historique pour le rétro-test par rapport au total des sources."
        }
      },
      "ai": {
        "context": "Contexte IA : {{reason}}"
      },
      "phases": {
        "learning": "Apprentissage",
        "scaling": "Mise à l'échelle",
        "stabilizing": "Stabilisation",
        "sunset": "Fin de vie",
        "testing": "Test",
        "paused": "En pause"
      }
    },
    "performance": {
      "title": "Analyse de performance",
      "kpiMetrics": "Indicateurs Clés (KPI)",
      "total": "TOTAL",
      "periodTotal": "TOTAL PÉRIODE",
      "aiInsight": "Analyse AI des Insights",
      "performanceVerdict": "Verdict de Performance",
      "topRecommendation": "Recommandation Principale",
      "applyOptimization": "Appliquer l'Optimisation",
      "helpfulTrend": "TENDANCE UTILE",
      "verdictPlaceholder": "Notre IA analyse actuellement vos données de performance. Nous avons constaté une amélioration de <0>{{percent}}%</0> de votre Panier Moyen par rapport au mois dernier.",
      "recommendationPlaceholder": "Votre ROAS atteint son pic les vendredis. Envisagez d'augmenter les dépenses publicitaires pour le week-end afin de maximiser le volume de conversion.",
      "kpis": {
        "grossSales": {
          "title": "Ventes Brutes",
          "desc": "Valeur totale de toutes les ventes avant déduction des remises ou retours."
        },
        "netSales": {
          "title": "Ventes Nettes",
          "desc": "Revenu réel provenant des ventes de produits après prise en compte des remises et retours."
        },
        "revenue": {
          "title": "Revenu Total",
          "desc": "Montant total généré par toutes les activités (ventes, expédition, etc.)."
        },
        "expenses": {
          "title": "Dépenses Totales",
          "desc": "Coûts opérationnels complets, y compris les coûts des produits, l'expédition, le marketing et les frais."
        },
        "net": {
          "title": "Flux de Trésorerie Net",
          "desc": "Bénéfice restant après déduction de toutes les dépenses du revenu total."
        },
        "margin": {
          "title": "Marge de Profit",
          "desc": "Pourcentage du revenu restant après couverture de tous les coûts."
        },
        "orders": {
          "title": "Commandes",
          "desc": "Nombre total de commandes uniques traitées au cours de la période sélectionnée."
        },
        "aov": {
          "title": "Panier Moyen",
          "desc": "Valeur Moyenne des Commandes (Average Order Value)."
        },
        "discountRate": {
          "title": "Taux de Remise",
          "desc": "Valeur totale des remises accordées en pourcentage des ventes brutes."
        },
        "returnRate": {
          "title": "Taux de Retour",
          "desc": "Valeur des produits retournés en pourcentage de vos ventes brutes totales."
        },
        "shippingRevenue": {
          "title": "Rev. Expédition",
          "desc": "Revenu total collecté auprès des clients pour l'expédition et la manutention."
        },
        "transactionFees": {
          "title": "Frais de Tx",
          "desc": "Frais payés aux processeurs de paiement (Stripe, PayPal, etc.)."
        },
        "txFeePercent": {
          "title": "Frais de Tx %",
          "desc": "Coût moyen du traitement des paiements en pourcentage du revenu total."
        },
        "customers": {
          "title": "Clients",
          "desc": "Nombre de personnes uniques ayant passé commande au cours de cette période."
        },
        "avgRevenuePerCustomer": {
          "title": "Rev./Client",
          "desc": "Revenu moyen généré par client unique."
        },
        "roas": {
          "title": "ROAS",
          "desc": "Retour sur les Dépenses Publicitaires (Return on Ad Spend)."
        },
        "cac": {
          "title": "CAC",
          "desc": "Coût d'Acquisition Client : dépenses marketing requises pour acquérir un nouveau client."
        },
        "adSpendPercent": {
          "title": "Dépenses Pub %",
          "desc": "Dépenses totales de marketing et publicité en pourcentage du revenu total."
        }
      }
    },
    "unableToRename": "Impossible de renommer la page. Veuillez réessayer.",
    "unableToDelete": "Impossible de supprimer la page. Veuillez réessayer.",
    "unableToReorder": "Impossible de réorganiser les pages. Veuillez réessayer.",
    "unableToSaveLayout": "Impossible d'enregistrer la disposition. Veuillez réessayer."
  },
  "onboarding": {
    "welcome": {
      "title": "Bienvenue sur Dashbal !",
      "description": "Configurons votre espace. Nous allons vous guider à travers les étapes clés pour visualiser vos données financières."
    },
    "createBoard": {
      "title": "Créez votre premier tableau",
      "description": "Commencez par créer un espace de travail où vous rassemblerez toutes vos données."
    },
    "addData": {
      "title": "Connectez vos données",
      "description": "Connectez des plateformes comme Shopify ou créez un Journal financier pour suivre vos opérations manuelles."
    },
    "addSpec": {
      "title": "Créez une spécification (Spec)",
      "description": "Définissez des formules personnalisées pour transformer vos données brutes en informations exploitables et indicateurs clés."
    },
    "completed": {
      "title": "Tout est prêt !",
      "description": "Vous avez terminé la configuration initiale. Vous pouvez maintenant explorer vos données."
    },
    "actions": {
      "next": "Compris !",
      "back": "Retour",
      "skip": "Passer le tour",
      "finish": "Compris !"
    }
  },
  "modal": "register",
  "journalTab": "shared",
  "verdicts": {
    "empty": {
      "title": "Collecte des signaux",
      "message": "Connectez vos canaux ou ajoutez des données historiques pour permettre à l'IA de générer un verdict."
    },
    "labels": {
      "aiInsight": "Aperçu de l'IA",
      "recommendation": "Principale recommandation",
      "missingSources": "Manquant pour une analyse complète :",
      "aiChat": "Analyse approfondie de l'IA",
      "strategicInsights": "Évaluation stratégique :"
    },
    "actions": {
      "analyzing": "Analyse en cours...",
      "startAnalysis": "Lancer l'analyse approfondie",
      "retry": "Réessayer",
      "askAiMore": "En savoir plus avec l'IA..."
    },
    "llm": {
      "trigger": {
        "title": "Analyse approfondie de l'IA",
        "desc": "Activez le moteur de corrélation multi-sources de l'IA pour trouver des opportunités de croissance cachées."
      },
      "analysisTitle": "Synthèse exécutive de l'IA"
    },
    "performance": {
      "EMPTY_STATE": {
        "title": "Collecte des signaux",
        "message": "Connectez vos canaux ou ajoutez des données historiques pour permettre à l'IA de générer un verdict.",
        "recommendation": "Connectez Shopify, WooCommerce ou ajoutez des journaux manuels pour commencer l'analyse."
      },
      "EFFICIENT_SCALING": {
        "title": "Opportunité de croissance efficace",
        "message": "Votre marge est solide ({{margin}}%) et le ROAS est efficace ({{roas}}x). Le chiffre d'affaires a augmenté de {{revGrowth}}%.",
        "recommendation": "Augmentez les d'épenses publicitaires sur les campagnes les plus performantes pour capturer plus de volume."
      },
      "MARGIN_CRUNCH": {
        "title": "Pression sur les marges",
        "message": "Le chiffre d'affaires est en hausse de {{revGrowth}}%, mais les marges sont tombées à {{margin}}%.",
        "recommendation": "Examinez les frais de traitement et l'efficacité des d'épenses publicitaires ; priorisez les produits à forte marge."
      },
      "REVENUE_DROP_ALARM": {
        "title": "Alerte de baisse de revenus",
        "message": "Le chiffre d'affaires a diminué de {{revGrowth}}% par rapport à la période précédente. Les bénéfices ont chuté de {{profitDelta}}%.",
        "recommendation": "Auditez les taux de conversion et les campagnes marketing actives pour identifier les problèmes potentiels."
      }
    },
    "traffic": {
      "EMPTY_STATE": {
        "title": "Prise d'élan",
        "message": "Aucun trafic ou revenu enregistré pour cette période.",
        "recommendation": "Vérifiez votre intégration Google Ads ou Meta Ads pour vous assurer que le suivi est actif."
      },
      "ORGANIC_OVERPOWERING": {
        "title": "Forte performance organique",
        "message": "Votre entreprise a un fort levier ! {{organicPercent}}% de vos revenus proviennent de canaux organiques.",
        "recommendation": "C'est le moment idéal pour augmenter progressivement le trafic payant tout en maintenant votre CAC bas."
      },
      "PAID_ADDICTION": {
        "title": "Haute dépendance au payant",
        "message": "{{paidPercent}}% de votre trafic est payant, tandis que la croissance des revenus n'est que de {{growth}}%.",
        "recommendation": "Investissez dans le SEO et l'e-mail marketing pour construire une valeur organique à long terme."
      }
    },
    "forecast": {
      "EMPTY_STATE": {
        "title": "Données de prévision requises",
        "message": "Données historiques insuffisantes pour générer des modèles de croissance fiables.",
        "recommendation": "Assurez-vous qu'au moins 30 jours de données historiques sont synchronisés pour des prévisions précises."
      },
      "GROWTH_AHEAD": {
        "title": "Prévision de croissance soutenue",
        "message": "Les tendances suggèrent une augmentation de {{projectedGrowth}}% du chiffre d'affaires au cours des 30 prochains jours.",
        "recommendation": "Assurez la disponibilité des stocks et prévoyez une augmentation de la capacité logistique."
      }
    },
    "cash flow": {
      "EMPTY_STATE": {
        "title": "Analyse des cycles de trésorerie",
        "message": "Les données de flux de trésorerie sont en attente de normalisation dans vos journaux et comptes.",
        "recommendation": "Liez vos principaux journaux bancaires ou plateformes comptables pour une analyse en temps réel."
      },
      "HEALTHY_RESERVES": {
        "title": "Position de trésorerie solide",
        "message": "Votre flux net actuel est positif avec une couverture de {{ratio}}x des d'épenses fixes.",
        "recommendation": "Envisagez de réinvestir l'excédent de trésorerie dans la R&D ou l'expansion."
      }
    },
    "errors": {
      "quota_exceeded": "Limite d'analyse hebdomadaire atteinte",
      "quota_exceeded_desc": "Vous avez utilisé tous vos jetons d'analyse approfondie de l'IA pour cette semaine.",
      "upgrade_plan": "Passez au plan Pro pour débloquer des analyses illimitées.",
      "reset_soon": "Votre quota commencera à se réinitialiser dans l'heure qui vient.",
      "reset_hours": "Votre quota commencera à se réinitialiser dans environ {{hours}} heures.",
      "reset_days": "Votre quota commencera à se réinitialiser dans quelques jours.",
      "quota_exceeded_default": "Votre quota hebdomadaire d'IA est actuellement épuisé.",
      "service_issue": "L'IA se repose momentanément",
      "service_issue_desc": "Nous avons rencontré un problème temporaire lors de la génération de votre analyse approfondie. Veuillez réessayer dans quelques instants.",
      "default": "Notre stratège IA est actuellement indisponible. Veuillez réessayer dans un instant.",
      "quota": "Votre quota d'analyse stratégique pour cette semaine a été atteint.",
      "notFound": "Nous n'avons pas pu trouver l'analyse demandée.",
      "rateLimit": "Trop de requêtes. Veuillez patienter quelques secondes."
    }
  },
  "exportOperations": {
    "title": "Export Operations",
    "subtitle": "Choose the best format for your needs",
    "formats": {
      "csvExcel": "CSV for Excel",
      "csvExcelDesc": "Optimized for Excel, Numbers, and other spreadsheet tools",
      "csvPlain": "Plain CSV",
      "csvPlainDesc": "Standard comma-separated values file"
    }
  },
  "details": {
    "loading": "Loading details..."
  },
  "ai": {
    "status": {
      "executionStarted": "Exécution commencée...",
      "executionComplete": "Exécution terminée.",
      "executionFailed": "Échec de l'exécution."
    }
  },
  "notices": {
    "syncSuccess": "Sync terminé : {{channelName}}",
    "syncError": "Échec de la synchronisation : {{channelName}}",
    "syncErrorCommercial": "Nous n'avons pas pu joindre {{channelName}} pour mettre à jour vos données.",
    "viewDetails": "Voir les détails"
  },
  "syncErrorModal": {
    "title": "Problème de connexion avec {{channelName}}",
    "message": "Nous avons rencontré un petit contretemps en essayant de récupérer les dernières mises à jour de votre compte **{{channelName}}**.",
    "suggestion": "Il se peut que vous deviez rafraîchir votre connexion si elle a expiré, ou simplement attendre un instant que la plateforme reprenne son souffle.",
    "close": "Fermer"
  },
  "docs": {
    "title": "Documentation",
    "searchPlaceholder": "Rechercher dans la documentation...",
    "backToHome": "Retour aux Tableaux",
    "wasHelpful": "Était-ce utile ?",
    "thanksFeedback": "Merci pour votre retour !",
    "yes": "Oui",
    "no": "Non",
    "lastUpdated": "Dernière mise à jour le {{date}}",
    "categories": {
      "gettingStarted": "Démarrage",
      "boards": "Tableaux & Composer",
      "connections": "Connexions de Données",
      "moneyJournal": "Money Journal",
      "ai": "Dashbal AI",
      "specs": "Métriques & Specs",
      "charts": "Graphiques & Analyses",
      "collaboration": "Partage & Collaboration",
      "billing": "Forfaits & Facturation"
    },
    "articles": {
      "accountSetup": "Configuration du compte",
      "profileSecurity": "Profil & Sécurité",
      "boardUsage": "Composer & Modèles",
      "boardManagement": "Gérer les tableaux",
      "addingPages": "Ajouter des pages",
      "connectingShopify": "Connecter Shopify",
      "connectingWooCommerce": "Connecter WooCommerce",
      "connectingAdChannels": "Connecter les canaux pubs",
      "addingConnectionToBoard": "Lier les données",
      "creatingMoneyJournal": "Créer des Journaux",
      "droppingFiles": "Dépôt de fichiers IA",
      "manualEntries": "Saisies manuelles",
      "talkingToAi": "Parler à l'IA",
      "aiCapabilities": "Capacités de l'IA",
      "understandingSpecs": "Comprendre les Specs",
      "formulaSyntax": "Syntaxe des formules",
      "chartCategories": "Guide des graphiques",
      "exportingData": "Exporter les données",
      "sharingBoards": "Partager avec l'équipe",
      "billingLimits": "Forfaits & Facturation",
      "planLimits": "Quotas & Limites IA"
    },
    "content": {
      "accountSetup": {
        "intro": "Bienvenue sur Dashbal. La configuration de votre compte est la première étape vers une visibilité financière unifiée sur tous vos canaux de vente et plateformes marketing.",
        "registrationTitle": "1. Inscription",
        "registrationContent": "Inscrivez-vous en utilisant votre e-mail professionnel ou l'un de nos fournisseurs sociaux pris en charge (Google, Apple, Meta). Nous vous recommandons d'utiliser votre e-mail professionnel pour simplifier la collaboration d'équipe et la gestion de l'espace de travail par la suite.",
        "verificationTitle": "2. Vérification de l'e-mail",
        "verificationContent": "Après l'inscription, vérifiez votre boîte de réception pour un lien de vérification. Cela garantit que vos données financières restent sécurisées et accessibles uniquement par vous.",
        "proTipTitle": "Conseil de pro",
        "proTipContent": "Vous pouvez activer l'authentification à deux facteurs (2FA) immédiatement après la connexion depuis vos paramètres de profil pour ajouter une couche de sécurité supplémentaire."
      },
      "profileSecurity": {
        "intro": "La protection de vos données financières est notre priorité absolue. Dashbal fournit des outils de sécurité de niveau entreprise pour garder votre compte en sécurité.",
        "bestPracticesTitle": "Meilleures pratiques de sécurité",
        "twoFactorTitle": "Utiliser la 2FA",
        "twoFactorContent": "Activez l'authentification basée sur TOTP (comme Google Authenticator) pour votre compte.",
        "sessionsTitle": "Surveiller les sessions",
        "sessionsContent": "Vérifiez régulièrement les 'Sessions actives' dans vos paramètres de sécurité pour vous assurer qu'il n'y a pas d'accès non autorisé."
      },
      "boardManagement": {
        "intro": "Les tableaux sont le cœur de Dashbal. Ils vous permettent d'organiser vos données par unité commerciale, région ou projet.",
        "createTitle": "Créer un tableau",
        "step1": "Cliquez sur 'Créer un tableau' dans la barre latérale du Board Explorer.",
        "step2": "Donnez un nom descriptif à votre tableau et choisissez sa devise principale.",
        "step3": "Sélectionnez un modèle ou commencez à partir d'une page blanche.",
        "note": "Note : Vous pouvez dupliquer des tableaux pour répliquer rapidement des structures de rapports réussies sur différents magasins."
      },
      "addingPages": {
        "intro": "Les tableaux peuvent contenir plusieurs pages, vous permettant de séparer différents types d'analyses (ex. : 'Aperçu', 'Marketing', 'Opérations') au sein d'un seul espace de travail.",
        "manageTitle": "Gérer les pages",
        "addTitle": "1. Ajouter une nouvelle page",
        "addContent": "Cliquez sur l'icône '+' dans la barre d'onglets des pages en bas de votre tableau. Vous pouvez choisir de partir d'un modèle ou d'une page blanche.",
        "renameTitle": "2. Renommer ou supprimer",
        "renameContent": "Double-cliquez sur un onglet de page pour le renommer, ou faites un clic droit pour voir les options de gestion, y compris 'Dupliquer' et 'Supprimer'.",
        "reorderTitle": "3. Réorganiser",
        "reorderContent": "Faites simplement glisser et déposez les onglets de page pour changer leur ordre."
      },
      "boardUsage": {
        "intro": "Les tableaux Dashbal disposent d'un puissant système Composer. Vous pouvez créer des mises en page de rapports sur mesure en utilisant le type de page 'Composer', permettant une flexibilité totale dans le placement et la taille des graphiques.",
        "interactionsTitle": "Utiliser le Composer",
        "dragTitle": "Créez le vôtre",
        "dragContent": "Sélectionnez le type de page 'Composer' lors de la création d'une nouvelle page pour débloquer le moteur de mise en page personnalisée.",
        "resizeTitle": "Modèles d'abord",
        "resizeContent": "Vous ne voulez pas partir de zéro ? Utilisez nos modèles validés par des experts pour peupler instantanément une page Composer avec les KPI les plus critiques pour votre type d'entreprise."
      },
      "connectingShopify": {
        "intro": "En tant que partenaire officiel de Shopify, Dashbal offre une intégration transparente en un clic qui synchronise vos commandes, produits et données d'expédition.",
        "setupTitle": "Installation de l'application officielle",
        "step1": "Allez dans la fenêtre 'Connecter un canal' et sélectionnez Shopify.",
        "step2": "Cliquez sur 'Installer l'application Dashbal' pour être redirigé vers le Shopify App Store.",
        "step3": "Connectez-vous à votre boutique et approuvez les autorisations requises. Dashbal commencera immédiatement la synchronisation historique."
      },
      "connectingWooCommerce": {
        "intro": "Connectez votre boutique WooCommerce en utilisant notre plugin connecteur WordPress haute performance.",
        "setupTitle": "Flux d'installation du plugin",
        "step1": "Téléchargez le fichier ZIP du connecteur Dashbal depuis l'écran de connexion WooCommerce.",
        "step2": "Dans votre administration WordPress, allez dans Extensions > Ajouter > Téléverser une extension et sélectionnez le fichier ZIP.",
        "step3": "Activez l'extension et cliquez sur 'Connecter à Dashbal' pour autoriser le flux de données sécurisé."
      },
      "connectingAdChannels": {
        "intro": "Dashbal s'intègre à Meta (Facebook/Instagram), TikTok et Google Ads en utilisant des protocoles OAuth 2.0 sécurisés.",
        "setupTitle": "Autorisation en un clic",
        "step1": "Sélectionnez votre plateforme publicitaire dans la liste 'Connecter un canal'.",
        "step2": "Une fenêtre contextuelle sécurisée s'ouvrira vous demandant de vous connecter à la plateforme (ex: Meta Business Suite).",
        "step3": "Accordez un accès en 'Lecture seule' à vos comptes publicitaires et insights. Dashbal ne demande jamais la permission de modifier vos publicités ou vos dépenses."
      },
      "chartCategories": {
        "intro": "Dashbal propose plus de 50 graphiques spécialisés dans divers domaines d'activité.",
        "financial": "Finance : Analyse P&L, Bénéfice Net et COGS.",
        "marketing": "Marketing : Suivi du ROAS, CAC et des dépenses multi-canaux.",
        "operations": "Opérations : Vitesse d'exécution et santé des stocks.",
        "growth": "Croissance : Analyse du LTV, de la rétention et des cohortes."
      },
      "billingLimits": {
        "intro": "Chaque forfait Dashbal est conçu pour évoluer avec la croissance de votre entreprise.",
        "pagesTitle": "Quotas de pages et de graphiques",
        "pagesContent": "Les forfaits gratuits permettent un nombre limité de pages et de graphiques par tableau. Les forfaits Pro offrent une évolutivité illimitée.",
        "historyTitle": "Historique des données",
        "historyContent": "Consultez une fenêtre limitée de données historiques sur les forfaits gratuits, ou un accès historique complet sur les niveaux premium."
      },
      "addingConnectionToBoard": {
        "intro": "Après avoir connecté vos comptes, vous devez les lier à des tableaux spécifiques pour commencer à voir les données dans vos graphiques.",
        "stepsTitle": "Comment lier les données :",
        "step1Title": "1. Ouvrir les connexions du tableau",
        "step1Content": "Cliquez sur le nom du tableau ou sur l'icône Connexions en haut à droite de l'en-tête de votre tableau.",
        "step2Title": "2. Ajouter une connexion",
        "step2Content": "Dans la fenêtre qui apparaît, cliquez sur 'Ajouter une connexion'.",
        "step3Title": "3. Sélectionner la source",
        "step3Content": "Choisissez 'Canal' ou 'Money Journal', puis sélectionnez votre compte spécifique (ex. : Boutique Shopify A) dans la liste.",
        "addConnectionLabel": "Ajouter une connexion"
      },
      "talkingToAi": {
        "intro": "Dashbal AI est votre analyste financier personnel. Au lieu de fouiller dans les graphiques, vous pouvez simplement poser des questions et obtenir des informations instantanées.",
        "bannerTitle": "Utiliser la bannière IA",
        "bannerContent": "Située au bas de chaque tableau, la bannière IA est toujours prête. Vous pouvez demander des choses comme :",
        "example1": "'Pourquoi mon profit a-t-il chuté la semaine dernière ?'",
        "example2": "'Crée un graphique en cascade pour mes dépenses marketing du T2.'",
        "example3": "'Quel est mon seuil de rentabilité actuel ?'",
        "example4": "'Compare les ventes Shopify aux dépenses Meta.'",
        "workflowTitle": "Valider & Exécuter",
        "workflowContent": "Lorsque vous demandez à l'IA de modifier votre tableau (ex. : 'Ajouter un graphique ROAS'), elle préparera une liste d'actions proposées. Vous gardez le contrôle : examinez les modifications et cliquez sur 'Valider & Exécuter' pour les appliquer.",
        "inputPlaceholder": "Posez votre question ici...",
        "activeStatus": "ANALYSTE IA ACTIF"
      },
      "planLimits": {
        "intro": "L'utilisation de Dashbal AI est mesurée en jetons et en quotas de conversation. Chaque forfait est assorti d'une allocation hebdomadaire.",
        "quotaTitle": "Jetons & Quotas IA",
        "resetTitle": "Réinitialisation hebdomadaire",
        "resetContent": "Votre quota de conversation IA est réinitialisé chaque dimanche à 00h00 UTC.",
        "usageTitle": "Suivre l'utilisation",
        "usageContent": "Vous pouvez consulter votre utilisation actuelle dans le panneau Historique IA (cliquez sur l'icône de l'horloge) ou dans vos paramètres de profil sous 'Forfait & Utilisation'."
      },
      "creatingMoneyJournal": {
        "intro": "Les Money Journals sont conçus pour le suivi des dépenses manuelles, de la trésorerie ou des sources de revenus qui n'ont pas d'intégration API.",
        "setupTitle": "Bien démarrer",
        "setupContent": "Naviguez vers l'onglet 'Money Journal' dans le Board Explorer. Ici, vous pouvez créer des journaux pour différents objectifs (ex. : 'Loyer du bureau', 'Revenus de conseil')."
      },
      "droppingFiles": {
        "intro": "Arrêtez la saisie manuelle des données. Déposez simplement vos factures, reçus ou relevés bancaires dans Dashbal et laissez notre IA faire le travail.",
        "extractionTitle": "Extraction de données IA",
        "engineTitle": "Moteur de traitement",
        "extractsTitle": "Extrait automatiquement :",
        "tag1": "Nom du fournisseur",
        "tag2": "Date",
        "tag3": "Montant total",
        "tag4": "TVA / Taxes",
        "tag5": "Devise"
      },
      "understandingSpecs": {
        "intro": "Les Specs (Métriques calculées) vous permettent de créer des KPI personnalisés à l'aide de notre puissant moteur de formules. Vous pouvez combiner des données provenant de différentes sources dans une seule métrique.",
        "casesTitle": "Exemples d'utilisation",
        "case1": "Calcul de la TVA : revenue * 0.20",
        "case2": "Profit réel : gross_profit - marketing_spend - rent_journal"
      }
    }
  },
  "billing": {
    "banner": {
      "graceTitle": "Action requise : restaurez votre facturation Shopify",
      "graceBody_one": "Restaurez la facturation dans les {{count}} jour ou votre compte passera en lecture seule.",
      "graceBody_other": "Restaurez la facturation dans les {{count}} jours ou votre compte passera en lecture seule.",
      "readOnlyTitle": "Votre compte est en lecture seule",
      "readOnlyBody_one": "Restaurez la facturation pour retrouver l'accès complet. Compte entièrement suspendu dans {{count}} jour.",
      "readOnlyBody_other": "Restaurez la facturation pour retrouver l'accès complet. Compte entièrement suspendu dans {{count}} jours.",
      "reinstallShopify": "Réinstaller sur Shopify",
      "subscribeWebsite": "S'abonner sur le site web",
      "reinstallTitle": "Réinstaller Dashbal sur Shopify",
      "reinstallBody": "Vous serez redirigé vers votre admin Shopify où vous pourrez réajouter l'application Dashbal pour restaurer la facturation.",
      "openShopify": "Ouvrir Shopify",
      "dismiss": "Ignorer"
    },
    "managedByShopify": {
      "title": "Facturé via Shopify",
      "body": "Votre abonnement est géré dans votre admin Shopify. Mettez à jour les moyens de paiement, changez de forfait ou annulez à partir de là.",
      "openShopify": "Gérer dans Shopify"
    },
    "suspended": {
      "title": "Compte suspendu",
      "body": "Votre compte est suspendu car la facturation n'a pas été restaurée à temps. Restaurez la facturation sur Shopify ou souscrivez un nouvel abonnement sur le site web pour le réactiver.",
      "restore": "Restaurer la facturation",
      "recoverHint": "Restaurez la facturation sur Shopify, ou souscrivez un nouvel abonnement sur le site web."
    }
  }
}